/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.geelevel = (function() {

    /**
     * Namespace geelevel.
     * @exports geelevel
     * @namespace
     */
    var geelevel = {};

    geelevel.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof geelevel
         * @namespace
         */
        var protobuf = {};

        protobuf.DeviceInfo = (function() {

            /**
             * Properties of a DeviceInfo.
             * @memberof geelevel.protobuf
             * @interface IDeviceInfo
             * @property {string|null} [data] DeviceInfo data
             */

            /**
             * Constructs a new DeviceInfo.
             * @memberof geelevel.protobuf
             * @classdesc Represents a DeviceInfo.
             * @implements IDeviceInfo
             * @constructor
             * @param {geelevel.protobuf.IDeviceInfo=} [properties] Properties to set
             */
            function DeviceInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DeviceInfo data.
             * @member {string} data
             * @memberof geelevel.protobuf.DeviceInfo
             * @instance
             */
            DeviceInfo.prototype.data = "";

            /**
             * Creates a new DeviceInfo instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.DeviceInfo
             * @static
             * @param {geelevel.protobuf.IDeviceInfo=} [properties] Properties to set
             * @returns {geelevel.protobuf.DeviceInfo} DeviceInfo instance
             */
            DeviceInfo.create = function create(properties) {
                return new DeviceInfo(properties);
            };

            /**
             * Encodes the specified DeviceInfo message. Does not implicitly {@link geelevel.protobuf.DeviceInfo.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.DeviceInfo
             * @static
             * @param {geelevel.protobuf.IDeviceInfo} message DeviceInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
                return writer;
            };

            /**
             * Encodes the specified DeviceInfo message, length delimited. Does not implicitly {@link geelevel.protobuf.DeviceInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.DeviceInfo
             * @static
             * @param {geelevel.protobuf.IDeviceInfo} message DeviceInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeviceInfo message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.DeviceInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.DeviceInfo} DeviceInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.DeviceInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.data = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeviceInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.DeviceInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.DeviceInfo} DeviceInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeviceInfo message.
             * @function verify
             * @memberof geelevel.protobuf.DeviceInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeviceInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!$util.isString(message.data))
                        return "data: string expected";
                return null;
            };

            /**
             * Creates a DeviceInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.DeviceInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.DeviceInfo} DeviceInfo
             */
            DeviceInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.DeviceInfo)
                    return object;
                var message = new $root.geelevel.protobuf.DeviceInfo();
                if (object.data != null)
                    message.data = String(object.data);
                return message;
            };

            /**
             * Creates a plain object from a DeviceInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.DeviceInfo
             * @static
             * @param {geelevel.protobuf.DeviceInfo} message DeviceInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeviceInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.data = "";
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = message.data;
                return object;
            };

            /**
             * Converts this DeviceInfo to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.DeviceInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeviceInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeviceInfo
             * @function getTypeUrl
             * @memberof geelevel.protobuf.DeviceInfo
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeviceInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.DeviceInfo";
            };

            return DeviceInfo;
        })();

        protobuf.JsonData = (function() {

            /**
             * Properties of a JsonData.
             * @memberof geelevel.protobuf
             * @interface IJsonData
             * @property {string|null} [data] JsonData data
             */

            /**
             * Constructs a new JsonData.
             * @memberof geelevel.protobuf
             * @classdesc Represents a JsonData.
             * @implements IJsonData
             * @constructor
             * @param {geelevel.protobuf.IJsonData=} [properties] Properties to set
             */
            function JsonData(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * JsonData data.
             * @member {string} data
             * @memberof geelevel.protobuf.JsonData
             * @instance
             */
            JsonData.prototype.data = "";

            /**
             * Creates a new JsonData instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.JsonData
             * @static
             * @param {geelevel.protobuf.IJsonData=} [properties] Properties to set
             * @returns {geelevel.protobuf.JsonData} JsonData instance
             */
            JsonData.create = function create(properties) {
                return new JsonData(properties);
            };

            /**
             * Encodes the specified JsonData message. Does not implicitly {@link geelevel.protobuf.JsonData.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.JsonData
             * @static
             * @param {geelevel.protobuf.IJsonData} message JsonData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            JsonData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
                return writer;
            };

            /**
             * Encodes the specified JsonData message, length delimited. Does not implicitly {@link geelevel.protobuf.JsonData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.JsonData
             * @static
             * @param {geelevel.protobuf.IJsonData} message JsonData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            JsonData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a JsonData message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.JsonData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.JsonData} JsonData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            JsonData.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.JsonData();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.data = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a JsonData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.JsonData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.JsonData} JsonData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            JsonData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a JsonData message.
             * @function verify
             * @memberof geelevel.protobuf.JsonData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            JsonData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!$util.isString(message.data))
                        return "data: string expected";
                return null;
            };

            /**
             * Creates a JsonData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.JsonData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.JsonData} JsonData
             */
            JsonData.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.JsonData)
                    return object;
                var message = new $root.geelevel.protobuf.JsonData();
                if (object.data != null)
                    message.data = String(object.data);
                return message;
            };

            /**
             * Creates a plain object from a JsonData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.JsonData
             * @static
             * @param {geelevel.protobuf.JsonData} message JsonData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            JsonData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.data = "";
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = message.data;
                return object;
            };

            /**
             * Converts this JsonData to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.JsonData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            JsonData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for JsonData
             * @function getTypeUrl
             * @memberof geelevel.protobuf.JsonData
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            JsonData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.JsonData";
            };

            return JsonData;
        })();

        protobuf.Call = (function() {

            /**
             * Properties of a Call.
             * @memberof geelevel.protobuf
             * @interface ICall
             * @property {string|null} [password] Call password
             * @property {number|null} [pwdType] Call pwdType
             */

            /**
             * Constructs a new Call.
             * @memberof geelevel.protobuf
             * @classdesc Represents a Call.
             * @implements ICall
             * @constructor
             * @param {geelevel.protobuf.ICall=} [properties] Properties to set
             */
            function Call(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Call password.
             * @member {string} password
             * @memberof geelevel.protobuf.Call
             * @instance
             */
            Call.prototype.password = "";

            /**
             * Call pwdType.
             * @member {number} pwdType
             * @memberof geelevel.protobuf.Call
             * @instance
             */
            Call.prototype.pwdType = 0;

            /**
             * Creates a new Call instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.Call
             * @static
             * @param {geelevel.protobuf.ICall=} [properties] Properties to set
             * @returns {geelevel.protobuf.Call} Call instance
             */
            Call.create = function create(properties) {
                return new Call(properties);
            };

            /**
             * Encodes the specified Call message. Does not implicitly {@link geelevel.protobuf.Call.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.Call
             * @static
             * @param {geelevel.protobuf.ICall} message Call message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Call.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.password);
                if (message.pwdType != null && Object.hasOwnProperty.call(message, "pwdType"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pwdType);
                return writer;
            };

            /**
             * Encodes the specified Call message, length delimited. Does not implicitly {@link geelevel.protobuf.Call.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.Call
             * @static
             * @param {geelevel.protobuf.ICall} message Call message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Call.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Call message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.Call
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.Call} Call
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Call.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.Call();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.password = reader.string();
                            break;
                        }
                    case 2: {
                            message.pwdType = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Call message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.Call
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.Call} Call
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Call.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Call message.
             * @function verify
             * @memberof geelevel.protobuf.Call
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Call.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.password != null && message.hasOwnProperty("password"))
                    if (!$util.isString(message.password))
                        return "password: string expected";
                if (message.pwdType != null && message.hasOwnProperty("pwdType"))
                    if (!$util.isInteger(message.pwdType))
                        return "pwdType: integer expected";
                return null;
            };

            /**
             * Creates a Call message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.Call
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.Call} Call
             */
            Call.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.Call)
                    return object;
                var message = new $root.geelevel.protobuf.Call();
                if (object.password != null)
                    message.password = String(object.password);
                if (object.pwdType != null)
                    message.pwdType = object.pwdType | 0;
                return message;
            };

            /**
             * Creates a plain object from a Call message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.Call
             * @static
             * @param {geelevel.protobuf.Call} message Call
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Call.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.password = "";
                    object.pwdType = 0;
                }
                if (message.password != null && message.hasOwnProperty("password"))
                    object.password = message.password;
                if (message.pwdType != null && message.hasOwnProperty("pwdType"))
                    object.pwdType = message.pwdType;
                return object;
            };

            /**
             * Converts this Call to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.Call
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Call.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Call
             * @function getTypeUrl
             * @memberof geelevel.protobuf.Call
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Call.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.Call";
            };

            return Call;
        })();

        protobuf.CallAck = (function() {

            /**
             * Properties of a CallAck.
             * @memberof geelevel.protobuf
             * @interface ICallAck
             * @property {number|null} [action] CallAck action
             * @property {number|null} [authorify] CallAck authorify
             * @property {number|null} [reason] CallAck reason
             */

            /**
             * Constructs a new CallAck.
             * @memberof geelevel.protobuf
             * @classdesc Represents a CallAck.
             * @implements ICallAck
             * @constructor
             * @param {geelevel.protobuf.ICallAck=} [properties] Properties to set
             */
            function CallAck(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CallAck action.
             * @member {number} action
             * @memberof geelevel.protobuf.CallAck
             * @instance
             */
            CallAck.prototype.action = 0;

            /**
             * CallAck authorify.
             * @member {number|null|undefined} authorify
             * @memberof geelevel.protobuf.CallAck
             * @instance
             */
            CallAck.prototype.authorify = null;

            /**
             * CallAck reason.
             * @member {number|null|undefined} reason
             * @memberof geelevel.protobuf.CallAck
             * @instance
             */
            CallAck.prototype.reason = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * CallAck ActionData.
             * @member {"authorify"|"reason"|undefined} ActionData
             * @memberof geelevel.protobuf.CallAck
             * @instance
             */
            Object.defineProperty(CallAck.prototype, "ActionData", {
                get: $util.oneOfGetter($oneOfFields = ["authorify", "reason"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new CallAck instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.CallAck
             * @static
             * @param {geelevel.protobuf.ICallAck=} [properties] Properties to set
             * @returns {geelevel.protobuf.CallAck} CallAck instance
             */
            CallAck.create = function create(properties) {
                return new CallAck(properties);
            };

            /**
             * Encodes the specified CallAck message. Does not implicitly {@link geelevel.protobuf.CallAck.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.CallAck
             * @static
             * @param {geelevel.protobuf.ICallAck} message CallAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CallAck.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.action);
                if (message.authorify != null && Object.hasOwnProperty.call(message, "authorify"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.authorify);
                if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.reason);
                return writer;
            };

            /**
             * Encodes the specified CallAck message, length delimited. Does not implicitly {@link geelevel.protobuf.CallAck.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.CallAck
             * @static
             * @param {geelevel.protobuf.ICallAck} message CallAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CallAck.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CallAck message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.CallAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.CallAck} CallAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CallAck.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.CallAck();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.action = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.authorify = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.reason = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CallAck message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.CallAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.CallAck} CallAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CallAck.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CallAck message.
             * @function verify
             * @memberof geelevel.protobuf.CallAck
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CallAck.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.action != null && message.hasOwnProperty("action"))
                    if (!$util.isInteger(message.action))
                        return "action: integer expected";
                if (message.authorify != null && message.hasOwnProperty("authorify")) {
                    properties.ActionData = 1;
                    if (!$util.isInteger(message.authorify))
                        return "authorify: integer expected";
                }
                if (message.reason != null && message.hasOwnProperty("reason")) {
                    if (properties.ActionData === 1)
                        return "ActionData: multiple values";
                    properties.ActionData = 1;
                    if (!$util.isInteger(message.reason))
                        return "reason: integer expected";
                }
                return null;
            };

            /**
             * Creates a CallAck message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.CallAck
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.CallAck} CallAck
             */
            CallAck.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.CallAck)
                    return object;
                var message = new $root.geelevel.protobuf.CallAck();
                if (object.action != null)
                    message.action = object.action >>> 0;
                if (object.authorify != null)
                    message.authorify = object.authorify >>> 0;
                if (object.reason != null)
                    message.reason = object.reason >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a CallAck message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.CallAck
             * @static
             * @param {geelevel.protobuf.CallAck} message CallAck
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CallAck.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.action = 0;
                if (message.action != null && message.hasOwnProperty("action"))
                    object.action = message.action;
                if (message.authorify != null && message.hasOwnProperty("authorify")) {
                    object.authorify = message.authorify;
                    if (options.oneofs)
                        object.ActionData = "authorify";
                }
                if (message.reason != null && message.hasOwnProperty("reason")) {
                    object.reason = message.reason;
                    if (options.oneofs)
                        object.ActionData = "reason";
                }
                return object;
            };

            /**
             * Converts this CallAck to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.CallAck
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CallAck.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CallAck
             * @function getTypeUrl
             * @memberof geelevel.protobuf.CallAck
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CallAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.CallAck";
            };

            return CallAck;
        })();

        protobuf.EndCall = (function() {

            /**
             * Properties of an EndCall.
             * @memberof geelevel.protobuf
             * @interface IEndCall
             * @property {number|null} [action] EndCall action
             * @property {number|null} [reason] EndCall reason
             */

            /**
             * Constructs a new EndCall.
             * @memberof geelevel.protobuf
             * @classdesc Represents an EndCall.
             * @implements IEndCall
             * @constructor
             * @param {geelevel.protobuf.IEndCall=} [properties] Properties to set
             */
            function EndCall(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EndCall action.
             * @member {number} action
             * @memberof geelevel.protobuf.EndCall
             * @instance
             */
            EndCall.prototype.action = 0;

            /**
             * EndCall reason.
             * @member {number} reason
             * @memberof geelevel.protobuf.EndCall
             * @instance
             */
            EndCall.prototype.reason = 0;

            /**
             * Creates a new EndCall instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.EndCall
             * @static
             * @param {geelevel.protobuf.IEndCall=} [properties] Properties to set
             * @returns {geelevel.protobuf.EndCall} EndCall instance
             */
            EndCall.create = function create(properties) {
                return new EndCall(properties);
            };

            /**
             * Encodes the specified EndCall message. Does not implicitly {@link geelevel.protobuf.EndCall.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.EndCall
             * @static
             * @param {geelevel.protobuf.IEndCall} message EndCall message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EndCall.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.action);
                if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.reason);
                return writer;
            };

            /**
             * Encodes the specified EndCall message, length delimited. Does not implicitly {@link geelevel.protobuf.EndCall.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.EndCall
             * @static
             * @param {geelevel.protobuf.IEndCall} message EndCall message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EndCall.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EndCall message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.EndCall
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.EndCall} EndCall
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EndCall.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.EndCall();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.action = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.reason = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EndCall message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.EndCall
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.EndCall} EndCall
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EndCall.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EndCall message.
             * @function verify
             * @memberof geelevel.protobuf.EndCall
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EndCall.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.action != null && message.hasOwnProperty("action"))
                    if (!$util.isInteger(message.action))
                        return "action: integer expected";
                if (message.reason != null && message.hasOwnProperty("reason"))
                    if (!$util.isInteger(message.reason))
                        return "reason: integer expected";
                return null;
            };

            /**
             * Creates an EndCall message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.EndCall
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.EndCall} EndCall
             */
            EndCall.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.EndCall)
                    return object;
                var message = new $root.geelevel.protobuf.EndCall();
                if (object.action != null)
                    message.action = object.action >>> 0;
                if (object.reason != null)
                    message.reason = object.reason >>> 0;
                return message;
            };

            /**
             * Creates a plain object from an EndCall message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.EndCall
             * @static
             * @param {geelevel.protobuf.EndCall} message EndCall
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EndCall.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.action = 0;
                    object.reason = 0;
                }
                if (message.action != null && message.hasOwnProperty("action"))
                    object.action = message.action;
                if (message.reason != null && message.hasOwnProperty("reason"))
                    object.reason = message.reason;
                return object;
            };

            /**
             * Converts this EndCall to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.EndCall
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EndCall.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EndCall
             * @function getTypeUrl
             * @memberof geelevel.protobuf.EndCall
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EndCall.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.EndCall";
            };

            return EndCall;
        })();

        protobuf.SetConnChannel = (function() {

            /**
             * Properties of a SetConnChannel.
             * @memberof geelevel.protobuf
             * @interface ISetConnChannel
             * @property {number|null} [value] SetConnChannel value
             */

            /**
             * Constructs a new SetConnChannel.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetConnChannel.
             * @implements ISetConnChannel
             * @constructor
             * @param {geelevel.protobuf.ISetConnChannel=} [properties] Properties to set
             */
            function SetConnChannel(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetConnChannel value.
             * @member {number} value
             * @memberof geelevel.protobuf.SetConnChannel
             * @instance
             */
            SetConnChannel.prototype.value = 0;

            /**
             * Creates a new SetConnChannel instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetConnChannel
             * @static
             * @param {geelevel.protobuf.ISetConnChannel=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetConnChannel} SetConnChannel instance
             */
            SetConnChannel.create = function create(properties) {
                return new SetConnChannel(properties);
            };

            /**
             * Encodes the specified SetConnChannel message. Does not implicitly {@link geelevel.protobuf.SetConnChannel.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetConnChannel
             * @static
             * @param {geelevel.protobuf.ISetConnChannel} message SetConnChannel message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetConnChannel.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.value);
                return writer;
            };

            /**
             * Encodes the specified SetConnChannel message, length delimited. Does not implicitly {@link geelevel.protobuf.SetConnChannel.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetConnChannel
             * @static
             * @param {geelevel.protobuf.ISetConnChannel} message SetConnChannel message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetConnChannel.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetConnChannel message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetConnChannel
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetConnChannel} SetConnChannel
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetConnChannel.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetConnChannel();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.value = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetConnChannel message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetConnChannel
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetConnChannel} SetConnChannel
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetConnChannel.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetConnChannel message.
             * @function verify
             * @memberof geelevel.protobuf.SetConnChannel
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetConnChannel.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value))
                        return "value: integer expected";
                return null;
            };

            /**
             * Creates a SetConnChannel message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetConnChannel
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetConnChannel} SetConnChannel
             */
            SetConnChannel.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetConnChannel)
                    return object;
                var message = new $root.geelevel.protobuf.SetConnChannel();
                if (object.value != null)
                    message.value = object.value >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SetConnChannel message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetConnChannel
             * @static
             * @param {geelevel.protobuf.SetConnChannel} message SetConnChannel
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetConnChannel.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this SetConnChannel to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetConnChannel
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetConnChannel.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetConnChannel
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetConnChannel
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetConnChannel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetConnChannel";
            };

            return SetConnChannel;
        })();

        protobuf.StartScreenCapture = (function() {

            /**
             * Properties of a StartScreenCapture.
             * @memberof geelevel.protobuf
             * @interface IStartScreenCapture
             * @property {number|null} [index] StartScreenCapture index
             */

            /**
             * Constructs a new StartScreenCapture.
             * @memberof geelevel.protobuf
             * @classdesc Represents a StartScreenCapture.
             * @implements IStartScreenCapture
             * @constructor
             * @param {geelevel.protobuf.IStartScreenCapture=} [properties] Properties to set
             */
            function StartScreenCapture(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StartScreenCapture index.
             * @member {number} index
             * @memberof geelevel.protobuf.StartScreenCapture
             * @instance
             */
            StartScreenCapture.prototype.index = 0;

            /**
             * Creates a new StartScreenCapture instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.StartScreenCapture
             * @static
             * @param {geelevel.protobuf.IStartScreenCapture=} [properties] Properties to set
             * @returns {geelevel.protobuf.StartScreenCapture} StartScreenCapture instance
             */
            StartScreenCapture.create = function create(properties) {
                return new StartScreenCapture(properties);
            };

            /**
             * Encodes the specified StartScreenCapture message. Does not implicitly {@link geelevel.protobuf.StartScreenCapture.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.StartScreenCapture
             * @static
             * @param {geelevel.protobuf.IStartScreenCapture} message StartScreenCapture message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartScreenCapture.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified StartScreenCapture message, length delimited. Does not implicitly {@link geelevel.protobuf.StartScreenCapture.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.StartScreenCapture
             * @static
             * @param {geelevel.protobuf.IStartScreenCapture} message StartScreenCapture message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartScreenCapture.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StartScreenCapture message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.StartScreenCapture
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.StartScreenCapture} StartScreenCapture
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartScreenCapture.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.StartScreenCapture();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StartScreenCapture message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.StartScreenCapture
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.StartScreenCapture} StartScreenCapture
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartScreenCapture.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StartScreenCapture message.
             * @function verify
             * @memberof geelevel.protobuf.StartScreenCapture
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StartScreenCapture.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a StartScreenCapture message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.StartScreenCapture
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.StartScreenCapture} StartScreenCapture
             */
            StartScreenCapture.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.StartScreenCapture)
                    return object;
                var message = new $root.geelevel.protobuf.StartScreenCapture();
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a StartScreenCapture message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.StartScreenCapture
             * @static
             * @param {geelevel.protobuf.StartScreenCapture} message StartScreenCapture
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StartScreenCapture.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.index = 0;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this StartScreenCapture to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.StartScreenCapture
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StartScreenCapture.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StartScreenCapture
             * @function getTypeUrl
             * @memberof geelevel.protobuf.StartScreenCapture
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StartScreenCapture.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.StartScreenCapture";
            };

            return StartScreenCapture;
        })();

        protobuf.StopScreenCapture = (function() {

            /**
             * Properties of a StopScreenCapture.
             * @memberof geelevel.protobuf
             * @interface IStopScreenCapture
             * @property {number|null} [index] StopScreenCapture index
             */

            /**
             * Constructs a new StopScreenCapture.
             * @memberof geelevel.protobuf
             * @classdesc Represents a StopScreenCapture.
             * @implements IStopScreenCapture
             * @constructor
             * @param {geelevel.protobuf.IStopScreenCapture=} [properties] Properties to set
             */
            function StopScreenCapture(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StopScreenCapture index.
             * @member {number} index
             * @memberof geelevel.protobuf.StopScreenCapture
             * @instance
             */
            StopScreenCapture.prototype.index = 0;

            /**
             * Creates a new StopScreenCapture instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.StopScreenCapture
             * @static
             * @param {geelevel.protobuf.IStopScreenCapture=} [properties] Properties to set
             * @returns {geelevel.protobuf.StopScreenCapture} StopScreenCapture instance
             */
            StopScreenCapture.create = function create(properties) {
                return new StopScreenCapture(properties);
            };

            /**
             * Encodes the specified StopScreenCapture message. Does not implicitly {@link geelevel.protobuf.StopScreenCapture.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.StopScreenCapture
             * @static
             * @param {geelevel.protobuf.IStopScreenCapture} message StopScreenCapture message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StopScreenCapture.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified StopScreenCapture message, length delimited. Does not implicitly {@link geelevel.protobuf.StopScreenCapture.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.StopScreenCapture
             * @static
             * @param {geelevel.protobuf.IStopScreenCapture} message StopScreenCapture message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StopScreenCapture.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StopScreenCapture message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.StopScreenCapture
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.StopScreenCapture} StopScreenCapture
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StopScreenCapture.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.StopScreenCapture();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StopScreenCapture message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.StopScreenCapture
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.StopScreenCapture} StopScreenCapture
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StopScreenCapture.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StopScreenCapture message.
             * @function verify
             * @memberof geelevel.protobuf.StopScreenCapture
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StopScreenCapture.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a StopScreenCapture message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.StopScreenCapture
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.StopScreenCapture} StopScreenCapture
             */
            StopScreenCapture.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.StopScreenCapture)
                    return object;
                var message = new $root.geelevel.protobuf.StopScreenCapture();
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a StopScreenCapture message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.StopScreenCapture
             * @static
             * @param {geelevel.protobuf.StopScreenCapture} message StopScreenCapture
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StopScreenCapture.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.index = 0;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this StopScreenCapture to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.StopScreenCapture
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StopScreenCapture.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StopScreenCapture
             * @function getTypeUrl
             * @memberof geelevel.protobuf.StopScreenCapture
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StopScreenCapture.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.StopScreenCapture";
            };

            return StopScreenCapture;
        })();

        protobuf.StartCameraCapture = (function() {

            /**
             * Properties of a StartCameraCapture.
             * @memberof geelevel.protobuf
             * @interface IStartCameraCapture
             * @property {number|null} [index] StartCameraCapture index
             */

            /**
             * Constructs a new StartCameraCapture.
             * @memberof geelevel.protobuf
             * @classdesc Represents a StartCameraCapture.
             * @implements IStartCameraCapture
             * @constructor
             * @param {geelevel.protobuf.IStartCameraCapture=} [properties] Properties to set
             */
            function StartCameraCapture(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StartCameraCapture index.
             * @member {number} index
             * @memberof geelevel.protobuf.StartCameraCapture
             * @instance
             */
            StartCameraCapture.prototype.index = 0;

            /**
             * Creates a new StartCameraCapture instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.StartCameraCapture
             * @static
             * @param {geelevel.protobuf.IStartCameraCapture=} [properties] Properties to set
             * @returns {geelevel.protobuf.StartCameraCapture} StartCameraCapture instance
             */
            StartCameraCapture.create = function create(properties) {
                return new StartCameraCapture(properties);
            };

            /**
             * Encodes the specified StartCameraCapture message. Does not implicitly {@link geelevel.protobuf.StartCameraCapture.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.StartCameraCapture
             * @static
             * @param {geelevel.protobuf.IStartCameraCapture} message StartCameraCapture message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartCameraCapture.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified StartCameraCapture message, length delimited. Does not implicitly {@link geelevel.protobuf.StartCameraCapture.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.StartCameraCapture
             * @static
             * @param {geelevel.protobuf.IStartCameraCapture} message StartCameraCapture message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StartCameraCapture.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StartCameraCapture message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.StartCameraCapture
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.StartCameraCapture} StartCameraCapture
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartCameraCapture.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.StartCameraCapture();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StartCameraCapture message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.StartCameraCapture
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.StartCameraCapture} StartCameraCapture
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StartCameraCapture.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StartCameraCapture message.
             * @function verify
             * @memberof geelevel.protobuf.StartCameraCapture
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StartCameraCapture.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a StartCameraCapture message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.StartCameraCapture
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.StartCameraCapture} StartCameraCapture
             */
            StartCameraCapture.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.StartCameraCapture)
                    return object;
                var message = new $root.geelevel.protobuf.StartCameraCapture();
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a StartCameraCapture message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.StartCameraCapture
             * @static
             * @param {geelevel.protobuf.StartCameraCapture} message StartCameraCapture
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StartCameraCapture.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.index = 0;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this StartCameraCapture to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.StartCameraCapture
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StartCameraCapture.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StartCameraCapture
             * @function getTypeUrl
             * @memberof geelevel.protobuf.StartCameraCapture
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StartCameraCapture.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.StartCameraCapture";
            };

            return StartCameraCapture;
        })();

        protobuf.StopCameraCapture = (function() {

            /**
             * Properties of a StopCameraCapture.
             * @memberof geelevel.protobuf
             * @interface IStopCameraCapture
             * @property {number|null} [index] StopCameraCapture index
             */

            /**
             * Constructs a new StopCameraCapture.
             * @memberof geelevel.protobuf
             * @classdesc Represents a StopCameraCapture.
             * @implements IStopCameraCapture
             * @constructor
             * @param {geelevel.protobuf.IStopCameraCapture=} [properties] Properties to set
             */
            function StopCameraCapture(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StopCameraCapture index.
             * @member {number} index
             * @memberof geelevel.protobuf.StopCameraCapture
             * @instance
             */
            StopCameraCapture.prototype.index = 0;

            /**
             * Creates a new StopCameraCapture instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.StopCameraCapture
             * @static
             * @param {geelevel.protobuf.IStopCameraCapture=} [properties] Properties to set
             * @returns {geelevel.protobuf.StopCameraCapture} StopCameraCapture instance
             */
            StopCameraCapture.create = function create(properties) {
                return new StopCameraCapture(properties);
            };

            /**
             * Encodes the specified StopCameraCapture message. Does not implicitly {@link geelevel.protobuf.StopCameraCapture.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.StopCameraCapture
             * @static
             * @param {geelevel.protobuf.IStopCameraCapture} message StopCameraCapture message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StopCameraCapture.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified StopCameraCapture message, length delimited. Does not implicitly {@link geelevel.protobuf.StopCameraCapture.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.StopCameraCapture
             * @static
             * @param {geelevel.protobuf.IStopCameraCapture} message StopCameraCapture message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StopCameraCapture.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StopCameraCapture message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.StopCameraCapture
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.StopCameraCapture} StopCameraCapture
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StopCameraCapture.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.StopCameraCapture();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StopCameraCapture message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.StopCameraCapture
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.StopCameraCapture} StopCameraCapture
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StopCameraCapture.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StopCameraCapture message.
             * @function verify
             * @memberof geelevel.protobuf.StopCameraCapture
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StopCameraCapture.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a StopCameraCapture message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.StopCameraCapture
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.StopCameraCapture} StopCameraCapture
             */
            StopCameraCapture.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.StopCameraCapture)
                    return object;
                var message = new $root.geelevel.protobuf.StopCameraCapture();
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a StopCameraCapture message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.StopCameraCapture
             * @static
             * @param {geelevel.protobuf.StopCameraCapture} message StopCameraCapture
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StopCameraCapture.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.index = 0;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this StopCameraCapture to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.StopCameraCapture
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StopCameraCapture.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StopCameraCapture
             * @function getTypeUrl
             * @memberof geelevel.protobuf.StopCameraCapture
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StopCameraCapture.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.StopCameraCapture";
            };

            return StopCameraCapture;
        })();

        protobuf.SetVideoEncoder = (function() {

            /**
             * Properties of a SetVideoEncoder.
             * @memberof geelevel.protobuf
             * @interface ISetVideoEncoder
             * @property {number|null} [value] SetVideoEncoder value
             * @property {number|null} [index] SetVideoEncoder index
             */

            /**
             * Constructs a new SetVideoEncoder.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetVideoEncoder.
             * @implements ISetVideoEncoder
             * @constructor
             * @param {geelevel.protobuf.ISetVideoEncoder=} [properties] Properties to set
             */
            function SetVideoEncoder(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetVideoEncoder value.
             * @member {number} value
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @instance
             */
            SetVideoEncoder.prototype.value = 0;

            /**
             * SetVideoEncoder index.
             * @member {number} index
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @instance
             */
            SetVideoEncoder.prototype.index = 0;

            /**
             * Creates a new SetVideoEncoder instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @static
             * @param {geelevel.protobuf.ISetVideoEncoder=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetVideoEncoder} SetVideoEncoder instance
             */
            SetVideoEncoder.create = function create(properties) {
                return new SetVideoEncoder(properties);
            };

            /**
             * Encodes the specified SetVideoEncoder message. Does not implicitly {@link geelevel.protobuf.SetVideoEncoder.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @static
             * @param {geelevel.protobuf.ISetVideoEncoder} message SetVideoEncoder message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoEncoder.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.value);
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified SetVideoEncoder message, length delimited. Does not implicitly {@link geelevel.protobuf.SetVideoEncoder.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @static
             * @param {geelevel.protobuf.ISetVideoEncoder} message SetVideoEncoder message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoEncoder.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetVideoEncoder message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetVideoEncoder} SetVideoEncoder
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoEncoder.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetVideoEncoder();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.value = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetVideoEncoder message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetVideoEncoder} SetVideoEncoder
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoEncoder.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetVideoEncoder message.
             * @function verify
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetVideoEncoder.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value))
                        return "value: integer expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a SetVideoEncoder message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetVideoEncoder} SetVideoEncoder
             */
            SetVideoEncoder.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetVideoEncoder)
                    return object;
                var message = new $root.geelevel.protobuf.SetVideoEncoder();
                if (object.value != null)
                    message.value = object.value >>> 0;
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SetVideoEncoder message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @static
             * @param {geelevel.protobuf.SetVideoEncoder} message SetVideoEncoder
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetVideoEncoder.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.value = 0;
                    object.index = 0;
                }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this SetVideoEncoder to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetVideoEncoder.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetVideoEncoder
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetVideoEncoder
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetVideoEncoder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetVideoEncoder";
            };

            return SetVideoEncoder;
        })();

        protobuf.SetResolution = (function() {

            /**
             * Properties of a SetResolution.
             * @memberof geelevel.protobuf
             * @interface ISetResolution
             * @property {number|null} [index] SetResolution index
             * @property {number|null} [width] SetResolution width
             * @property {number|null} [height] SetResolution height
             * @property {number|null} [x] SetResolution x
             * @property {number|null} [y] SetResolution y
             * @property {number|null} [multiple] SetResolution multiple
             */

            /**
             * Constructs a new SetResolution.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetResolution.
             * @implements ISetResolution
             * @constructor
             * @param {geelevel.protobuf.ISetResolution=} [properties] Properties to set
             */
            function SetResolution(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetResolution index.
             * @member {number} index
             * @memberof geelevel.protobuf.SetResolution
             * @instance
             */
            SetResolution.prototype.index = 0;

            /**
             * SetResolution width.
             * @member {number} width
             * @memberof geelevel.protobuf.SetResolution
             * @instance
             */
            SetResolution.prototype.width = 0;

            /**
             * SetResolution height.
             * @member {number} height
             * @memberof geelevel.protobuf.SetResolution
             * @instance
             */
            SetResolution.prototype.height = 0;

            /**
             * SetResolution x.
             * @member {number} x
             * @memberof geelevel.protobuf.SetResolution
             * @instance
             */
            SetResolution.prototype.x = 0;

            /**
             * SetResolution y.
             * @member {number} y
             * @memberof geelevel.protobuf.SetResolution
             * @instance
             */
            SetResolution.prototype.y = 0;

            /**
             * SetResolution multiple.
             * @member {number} multiple
             * @memberof geelevel.protobuf.SetResolution
             * @instance
             */
            SetResolution.prototype.multiple = 0;

            /**
             * Creates a new SetResolution instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetResolution
             * @static
             * @param {geelevel.protobuf.ISetResolution=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetResolution} SetResolution instance
             */
            SetResolution.create = function create(properties) {
                return new SetResolution(properties);
            };

            /**
             * Encodes the specified SetResolution message. Does not implicitly {@link geelevel.protobuf.SetResolution.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetResolution
             * @static
             * @param {geelevel.protobuf.ISetResolution} message SetResolution message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetResolution.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.width);
                if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.height);
                if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.x);
                if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.y);
                if (message.multiple != null && Object.hasOwnProperty.call(message, "multiple"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.multiple);
                return writer;
            };

            /**
             * Encodes the specified SetResolution message, length delimited. Does not implicitly {@link geelevel.protobuf.SetResolution.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetResolution
             * @static
             * @param {geelevel.protobuf.ISetResolution} message SetResolution message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetResolution.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetResolution message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetResolution
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetResolution} SetResolution
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetResolution.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetResolution();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.width = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.height = reader.uint32();
                            break;
                        }
                    case 4: {
                            message.x = reader.int32();
                            break;
                        }
                    case 5: {
                            message.y = reader.int32();
                            break;
                        }
                    case 6: {
                            message.multiple = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetResolution message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetResolution
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetResolution} SetResolution
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetResolution.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetResolution message.
             * @function verify
             * @memberof geelevel.protobuf.SetResolution
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetResolution.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                if (message.width != null && message.hasOwnProperty("width"))
                    if (!$util.isInteger(message.width))
                        return "width: integer expected";
                if (message.height != null && message.hasOwnProperty("height"))
                    if (!$util.isInteger(message.height))
                        return "height: integer expected";
                if (message.x != null && message.hasOwnProperty("x"))
                    if (!$util.isInteger(message.x))
                        return "x: integer expected";
                if (message.y != null && message.hasOwnProperty("y"))
                    if (!$util.isInteger(message.y))
                        return "y: integer expected";
                if (message.multiple != null && message.hasOwnProperty("multiple"))
                    if (!$util.isInteger(message.multiple))
                        return "multiple: integer expected";
                return null;
            };

            /**
             * Creates a SetResolution message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetResolution
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetResolution} SetResolution
             */
            SetResolution.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetResolution)
                    return object;
                var message = new $root.geelevel.protobuf.SetResolution();
                if (object.index != null)
                    message.index = object.index >>> 0;
                if (object.width != null)
                    message.width = object.width >>> 0;
                if (object.height != null)
                    message.height = object.height >>> 0;
                if (object.x != null)
                    message.x = object.x | 0;
                if (object.y != null)
                    message.y = object.y | 0;
                if (object.multiple != null)
                    message.multiple = object.multiple | 0;
                return message;
            };

            /**
             * Creates a plain object from a SetResolution message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetResolution
             * @static
             * @param {geelevel.protobuf.SetResolution} message SetResolution
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetResolution.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.index = 0;
                    object.width = 0;
                    object.height = 0;
                    object.x = 0;
                    object.y = 0;
                    object.multiple = 0;
                }
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                if (message.width != null && message.hasOwnProperty("width"))
                    object.width = message.width;
                if (message.height != null && message.hasOwnProperty("height"))
                    object.height = message.height;
                if (message.x != null && message.hasOwnProperty("x"))
                    object.x = message.x;
                if (message.y != null && message.hasOwnProperty("y"))
                    object.y = message.y;
                if (message.multiple != null && message.hasOwnProperty("multiple"))
                    object.multiple = message.multiple;
                return object;
            };

            /**
             * Converts this SetResolution to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetResolution
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetResolution.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetResolution
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetResolution
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetResolution.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetResolution";
            };

            return SetResolution;
        })();

        protobuf.SetWallpaper = (function() {

            /**
             * Properties of a SetWallpaper.
             * @memberof geelevel.protobuf
             * @interface ISetWallpaper
             * @property {string|null} [picUrl] SetWallpaper picUrl
             */

            /**
             * Constructs a new SetWallpaper.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetWallpaper.
             * @implements ISetWallpaper
             * @constructor
             * @param {geelevel.protobuf.ISetWallpaper=} [properties] Properties to set
             */
            function SetWallpaper(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetWallpaper picUrl.
             * @member {string} picUrl
             * @memberof geelevel.protobuf.SetWallpaper
             * @instance
             */
            SetWallpaper.prototype.picUrl = "";

            /**
             * Creates a new SetWallpaper instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetWallpaper
             * @static
             * @param {geelevel.protobuf.ISetWallpaper=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetWallpaper} SetWallpaper instance
             */
            SetWallpaper.create = function create(properties) {
                return new SetWallpaper(properties);
            };

            /**
             * Encodes the specified SetWallpaper message. Does not implicitly {@link geelevel.protobuf.SetWallpaper.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetWallpaper
             * @static
             * @param {geelevel.protobuf.ISetWallpaper} message SetWallpaper message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetWallpaper.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.picUrl != null && Object.hasOwnProperty.call(message, "picUrl"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.picUrl);
                return writer;
            };

            /**
             * Encodes the specified SetWallpaper message, length delimited. Does not implicitly {@link geelevel.protobuf.SetWallpaper.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetWallpaper
             * @static
             * @param {geelevel.protobuf.ISetWallpaper} message SetWallpaper message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetWallpaper.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetWallpaper message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetWallpaper
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetWallpaper} SetWallpaper
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetWallpaper.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetWallpaper();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.picUrl = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetWallpaper message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetWallpaper
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetWallpaper} SetWallpaper
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetWallpaper.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetWallpaper message.
             * @function verify
             * @memberof geelevel.protobuf.SetWallpaper
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetWallpaper.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.picUrl != null && message.hasOwnProperty("picUrl"))
                    if (!$util.isString(message.picUrl))
                        return "picUrl: string expected";
                return null;
            };

            /**
             * Creates a SetWallpaper message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetWallpaper
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetWallpaper} SetWallpaper
             */
            SetWallpaper.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetWallpaper)
                    return object;
                var message = new $root.geelevel.protobuf.SetWallpaper();
                if (object.picUrl != null)
                    message.picUrl = String(object.picUrl);
                return message;
            };

            /**
             * Creates a plain object from a SetWallpaper message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetWallpaper
             * @static
             * @param {geelevel.protobuf.SetWallpaper} message SetWallpaper
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetWallpaper.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.picUrl = "";
                if (message.picUrl != null && message.hasOwnProperty("picUrl"))
                    object.picUrl = message.picUrl;
                return object;
            };

            /**
             * Converts this SetWallpaper to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetWallpaper
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetWallpaper.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetWallpaper
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetWallpaper
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetWallpaper.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetWallpaper";
            };

            return SetWallpaper;
        })();

        protobuf.SetDpi = (function() {

            /**
             * Properties of a SetDpi.
             * @memberof geelevel.protobuf
             * @interface ISetDpi
             * @property {number|null} [index] SetDpi index
             * @property {number|null} [dpi] SetDpi dpi
             */

            /**
             * Constructs a new SetDpi.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetDpi.
             * @implements ISetDpi
             * @constructor
             * @param {geelevel.protobuf.ISetDpi=} [properties] Properties to set
             */
            function SetDpi(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetDpi index.
             * @member {number} index
             * @memberof geelevel.protobuf.SetDpi
             * @instance
             */
            SetDpi.prototype.index = 0;

            /**
             * SetDpi dpi.
             * @member {number} dpi
             * @memberof geelevel.protobuf.SetDpi
             * @instance
             */
            SetDpi.prototype.dpi = 0;

            /**
             * Creates a new SetDpi instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetDpi
             * @static
             * @param {geelevel.protobuf.ISetDpi=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetDpi} SetDpi instance
             */
            SetDpi.create = function create(properties) {
                return new SetDpi(properties);
            };

            /**
             * Encodes the specified SetDpi message. Does not implicitly {@link geelevel.protobuf.SetDpi.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetDpi
             * @static
             * @param {geelevel.protobuf.ISetDpi} message SetDpi message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetDpi.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                if (message.dpi != null && Object.hasOwnProperty.call(message, "dpi"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.dpi);
                return writer;
            };

            /**
             * Encodes the specified SetDpi message, length delimited. Does not implicitly {@link geelevel.protobuf.SetDpi.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetDpi
             * @static
             * @param {geelevel.protobuf.ISetDpi} message SetDpi message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetDpi.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetDpi message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetDpi
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetDpi} SetDpi
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetDpi.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetDpi();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.dpi = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetDpi message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetDpi
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetDpi} SetDpi
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetDpi.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetDpi message.
             * @function verify
             * @memberof geelevel.protobuf.SetDpi
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetDpi.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                if (message.dpi != null && message.hasOwnProperty("dpi"))
                    if (!$util.isInteger(message.dpi))
                        return "dpi: integer expected";
                return null;
            };

            /**
             * Creates a SetDpi message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetDpi
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetDpi} SetDpi
             */
            SetDpi.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetDpi)
                    return object;
                var message = new $root.geelevel.protobuf.SetDpi();
                if (object.index != null)
                    message.index = object.index >>> 0;
                if (object.dpi != null)
                    message.dpi = object.dpi >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SetDpi message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetDpi
             * @static
             * @param {geelevel.protobuf.SetDpi} message SetDpi
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetDpi.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.index = 0;
                    object.dpi = 0;
                }
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                if (message.dpi != null && message.hasOwnProperty("dpi"))
                    object.dpi = message.dpi;
                return object;
            };

            /**
             * Converts this SetDpi to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetDpi
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetDpi.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetDpi
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetDpi
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetDpi.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetDpi";
            };

            return SetDpi;
        })();

        protobuf.GetDpi = (function() {

            /**
             * Properties of a GetDpi.
             * @memberof geelevel.protobuf
             * @interface IGetDpi
             * @property {number|null} [index] GetDpi index
             */

            /**
             * Constructs a new GetDpi.
             * @memberof geelevel.protobuf
             * @classdesc Represents a GetDpi.
             * @implements IGetDpi
             * @constructor
             * @param {geelevel.protobuf.IGetDpi=} [properties] Properties to set
             */
            function GetDpi(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GetDpi index.
             * @member {number} index
             * @memberof geelevel.protobuf.GetDpi
             * @instance
             */
            GetDpi.prototype.index = 0;

            /**
             * Creates a new GetDpi instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.GetDpi
             * @static
             * @param {geelevel.protobuf.IGetDpi=} [properties] Properties to set
             * @returns {geelevel.protobuf.GetDpi} GetDpi instance
             */
            GetDpi.create = function create(properties) {
                return new GetDpi(properties);
            };

            /**
             * Encodes the specified GetDpi message. Does not implicitly {@link geelevel.protobuf.GetDpi.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.GetDpi
             * @static
             * @param {geelevel.protobuf.IGetDpi} message GetDpi message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDpi.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified GetDpi message, length delimited. Does not implicitly {@link geelevel.protobuf.GetDpi.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.GetDpi
             * @static
             * @param {geelevel.protobuf.IGetDpi} message GetDpi message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GetDpi.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GetDpi message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.GetDpi
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.GetDpi} GetDpi
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDpi.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.GetDpi();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GetDpi message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.GetDpi
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.GetDpi} GetDpi
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GetDpi.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GetDpi message.
             * @function verify
             * @memberof geelevel.protobuf.GetDpi
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GetDpi.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a GetDpi message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.GetDpi
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.GetDpi} GetDpi
             */
            GetDpi.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.GetDpi)
                    return object;
                var message = new $root.geelevel.protobuf.GetDpi();
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a GetDpi message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.GetDpi
             * @static
             * @param {geelevel.protobuf.GetDpi} message GetDpi
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GetDpi.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.index = 0;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this GetDpi to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.GetDpi
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GetDpi.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GetDpi
             * @function getTypeUrl
             * @memberof geelevel.protobuf.GetDpi
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GetDpi.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.GetDpi";
            };

            return GetDpi;
        })();

        protobuf.DpiInfo = (function() {

            /**
             * Properties of a DpiInfo.
             * @memberof geelevel.protobuf
             * @interface IDpiInfo
             * @property {number|null} [index] DpiInfo index
             * @property {number|null} [currentDpi] DpiInfo currentDpi
             * @property {number|null} [recommendedDpiIndex] DpiInfo recommendedDpiIndex
             * @property {Array.<number>|null} [dpiList] DpiInfo dpiList
             */

            /**
             * Constructs a new DpiInfo.
             * @memberof geelevel.protobuf
             * @classdesc Represents a DpiInfo.
             * @implements IDpiInfo
             * @constructor
             * @param {geelevel.protobuf.IDpiInfo=} [properties] Properties to set
             */
            function DpiInfo(properties) {
                this.dpiList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DpiInfo index.
             * @member {number} index
             * @memberof geelevel.protobuf.DpiInfo
             * @instance
             */
            DpiInfo.prototype.index = 0;

            /**
             * DpiInfo currentDpi.
             * @member {number} currentDpi
             * @memberof geelevel.protobuf.DpiInfo
             * @instance
             */
            DpiInfo.prototype.currentDpi = 0;

            /**
             * DpiInfo recommendedDpiIndex.
             * @member {number} recommendedDpiIndex
             * @memberof geelevel.protobuf.DpiInfo
             * @instance
             */
            DpiInfo.prototype.recommendedDpiIndex = 0;

            /**
             * DpiInfo dpiList.
             * @member {Array.<number>} dpiList
             * @memberof geelevel.protobuf.DpiInfo
             * @instance
             */
            DpiInfo.prototype.dpiList = $util.emptyArray;

            /**
             * Creates a new DpiInfo instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.DpiInfo
             * @static
             * @param {geelevel.protobuf.IDpiInfo=} [properties] Properties to set
             * @returns {geelevel.protobuf.DpiInfo} DpiInfo instance
             */
            DpiInfo.create = function create(properties) {
                return new DpiInfo(properties);
            };

            /**
             * Encodes the specified DpiInfo message. Does not implicitly {@link geelevel.protobuf.DpiInfo.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.DpiInfo
             * @static
             * @param {geelevel.protobuf.IDpiInfo} message DpiInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DpiInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                if (message.currentDpi != null && Object.hasOwnProperty.call(message, "currentDpi"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.currentDpi);
                if (message.recommendedDpiIndex != null && Object.hasOwnProperty.call(message, "recommendedDpiIndex"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.recommendedDpiIndex);
                if (message.dpiList != null && message.dpiList.length) {
                    writer.uint32(/* id 4, wireType 2 =*/34).fork();
                    for (var i = 0; i < message.dpiList.length; ++i)
                        writer.uint32(message.dpiList[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Encodes the specified DpiInfo message, length delimited. Does not implicitly {@link geelevel.protobuf.DpiInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.DpiInfo
             * @static
             * @param {geelevel.protobuf.IDpiInfo} message DpiInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DpiInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DpiInfo message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.DpiInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.DpiInfo} DpiInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DpiInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.DpiInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.currentDpi = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.recommendedDpiIndex = reader.uint32();
                            break;
                        }
                    case 4: {
                            if (!(message.dpiList && message.dpiList.length))
                                message.dpiList = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.dpiList.push(reader.uint32());
                            } else
                                message.dpiList.push(reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DpiInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.DpiInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.DpiInfo} DpiInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DpiInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DpiInfo message.
             * @function verify
             * @memberof geelevel.protobuf.DpiInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DpiInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                if (message.currentDpi != null && message.hasOwnProperty("currentDpi"))
                    if (!$util.isInteger(message.currentDpi))
                        return "currentDpi: integer expected";
                if (message.recommendedDpiIndex != null && message.hasOwnProperty("recommendedDpiIndex"))
                    if (!$util.isInteger(message.recommendedDpiIndex))
                        return "recommendedDpiIndex: integer expected";
                if (message.dpiList != null && message.hasOwnProperty("dpiList")) {
                    if (!Array.isArray(message.dpiList))
                        return "dpiList: array expected";
                    for (var i = 0; i < message.dpiList.length; ++i)
                        if (!$util.isInteger(message.dpiList[i]))
                            return "dpiList: integer[] expected";
                }
                return null;
            };

            /**
             * Creates a DpiInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.DpiInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.DpiInfo} DpiInfo
             */
            DpiInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.DpiInfo)
                    return object;
                var message = new $root.geelevel.protobuf.DpiInfo();
                if (object.index != null)
                    message.index = object.index >>> 0;
                if (object.currentDpi != null)
                    message.currentDpi = object.currentDpi >>> 0;
                if (object.recommendedDpiIndex != null)
                    message.recommendedDpiIndex = object.recommendedDpiIndex >>> 0;
                if (object.dpiList) {
                    if (!Array.isArray(object.dpiList))
                        throw TypeError(".geelevel.protobuf.DpiInfo.dpiList: array expected");
                    message.dpiList = [];
                    for (var i = 0; i < object.dpiList.length; ++i)
                        message.dpiList[i] = object.dpiList[i] >>> 0;
                }
                return message;
            };

            /**
             * Creates a plain object from a DpiInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.DpiInfo
             * @static
             * @param {geelevel.protobuf.DpiInfo} message DpiInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DpiInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.dpiList = [];
                if (options.defaults) {
                    object.index = 0;
                    object.currentDpi = 0;
                    object.recommendedDpiIndex = 0;
                }
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                if (message.currentDpi != null && message.hasOwnProperty("currentDpi"))
                    object.currentDpi = message.currentDpi;
                if (message.recommendedDpiIndex != null && message.hasOwnProperty("recommendedDpiIndex"))
                    object.recommendedDpiIndex = message.recommendedDpiIndex;
                if (message.dpiList && message.dpiList.length) {
                    object.dpiList = [];
                    for (var j = 0; j < message.dpiList.length; ++j)
                        object.dpiList[j] = message.dpiList[j];
                }
                return object;
            };

            /**
             * Converts this DpiInfo to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.DpiInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DpiInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DpiInfo
             * @function getTypeUrl
             * @memberof geelevel.protobuf.DpiInfo
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DpiInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.DpiInfo";
            };

            return DpiInfo;
        })();

        protobuf.SetScreenPosition = (function() {

            /**
             * Properties of a SetScreenPosition.
             * @memberof geelevel.protobuf
             * @interface ISetScreenPosition
             * @property {number|null} [index] SetScreenPosition index
             * @property {number|null} [base] SetScreenPosition base
             * @property {number|null} [position] SetScreenPosition position
             * @property {number|null} [rotation] SetScreenPosition rotation
             * @property {number|null} [offsetX] SetScreenPosition offsetX
             * @property {number|null} [offsetY] SetScreenPosition offsetY
             */

            /**
             * Constructs a new SetScreenPosition.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetScreenPosition.
             * @implements ISetScreenPosition
             * @constructor
             * @param {geelevel.protobuf.ISetScreenPosition=} [properties] Properties to set
             */
            function SetScreenPosition(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetScreenPosition index.
             * @member {number} index
             * @memberof geelevel.protobuf.SetScreenPosition
             * @instance
             */
            SetScreenPosition.prototype.index = 0;

            /**
             * SetScreenPosition base.
             * @member {number} base
             * @memberof geelevel.protobuf.SetScreenPosition
             * @instance
             */
            SetScreenPosition.prototype.base = 0;

            /**
             * SetScreenPosition position.
             * @member {number} position
             * @memberof geelevel.protobuf.SetScreenPosition
             * @instance
             */
            SetScreenPosition.prototype.position = 0;

            /**
             * SetScreenPosition rotation.
             * @member {number} rotation
             * @memberof geelevel.protobuf.SetScreenPosition
             * @instance
             */
            SetScreenPosition.prototype.rotation = 0;

            /**
             * SetScreenPosition offsetX.
             * @member {number} offsetX
             * @memberof geelevel.protobuf.SetScreenPosition
             * @instance
             */
            SetScreenPosition.prototype.offsetX = 0;

            /**
             * SetScreenPosition offsetY.
             * @member {number} offsetY
             * @memberof geelevel.protobuf.SetScreenPosition
             * @instance
             */
            SetScreenPosition.prototype.offsetY = 0;

            /**
             * Creates a new SetScreenPosition instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetScreenPosition
             * @static
             * @param {geelevel.protobuf.ISetScreenPosition=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetScreenPosition} SetScreenPosition instance
             */
            SetScreenPosition.create = function create(properties) {
                return new SetScreenPosition(properties);
            };

            /**
             * Encodes the specified SetScreenPosition message. Does not implicitly {@link geelevel.protobuf.SetScreenPosition.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetScreenPosition
             * @static
             * @param {geelevel.protobuf.ISetScreenPosition} message SetScreenPosition message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetScreenPosition.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.base);
                if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.position);
                if (message.rotation != null && Object.hasOwnProperty.call(message, "rotation"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.rotation);
                if (message.offsetX != null && Object.hasOwnProperty.call(message, "offsetX"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.offsetX);
                if (message.offsetY != null && Object.hasOwnProperty.call(message, "offsetY"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.offsetY);
                return writer;
            };

            /**
             * Encodes the specified SetScreenPosition message, length delimited. Does not implicitly {@link geelevel.protobuf.SetScreenPosition.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetScreenPosition
             * @static
             * @param {geelevel.protobuf.ISetScreenPosition} message SetScreenPosition message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetScreenPosition.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetScreenPosition message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetScreenPosition
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetScreenPosition} SetScreenPosition
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetScreenPosition.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetScreenPosition();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.base = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.position = reader.uint32();
                            break;
                        }
                    case 4: {
                            message.rotation = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.offsetX = reader.int32();
                            break;
                        }
                    case 6: {
                            message.offsetY = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetScreenPosition message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetScreenPosition
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetScreenPosition} SetScreenPosition
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetScreenPosition.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetScreenPosition message.
             * @function verify
             * @memberof geelevel.protobuf.SetScreenPosition
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetScreenPosition.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                if (message.base != null && message.hasOwnProperty("base"))
                    if (!$util.isInteger(message.base))
                        return "base: integer expected";
                if (message.position != null && message.hasOwnProperty("position"))
                    if (!$util.isInteger(message.position))
                        return "position: integer expected";
                if (message.rotation != null && message.hasOwnProperty("rotation"))
                    if (!$util.isInteger(message.rotation))
                        return "rotation: integer expected";
                if (message.offsetX != null && message.hasOwnProperty("offsetX"))
                    if (!$util.isInteger(message.offsetX))
                        return "offsetX: integer expected";
                if (message.offsetY != null && message.hasOwnProperty("offsetY"))
                    if (!$util.isInteger(message.offsetY))
                        return "offsetY: integer expected";
                return null;
            };

            /**
             * Creates a SetScreenPosition message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetScreenPosition
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetScreenPosition} SetScreenPosition
             */
            SetScreenPosition.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetScreenPosition)
                    return object;
                var message = new $root.geelevel.protobuf.SetScreenPosition();
                if (object.index != null)
                    message.index = object.index >>> 0;
                if (object.base != null)
                    message.base = object.base >>> 0;
                if (object.position != null)
                    message.position = object.position >>> 0;
                if (object.rotation != null)
                    message.rotation = object.rotation >>> 0;
                if (object.offsetX != null)
                    message.offsetX = object.offsetX | 0;
                if (object.offsetY != null)
                    message.offsetY = object.offsetY | 0;
                return message;
            };

            /**
             * Creates a plain object from a SetScreenPosition message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetScreenPosition
             * @static
             * @param {geelevel.protobuf.SetScreenPosition} message SetScreenPosition
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetScreenPosition.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.index = 0;
                    object.base = 0;
                    object.position = 0;
                    object.rotation = 0;
                    object.offsetX = 0;
                    object.offsetY = 0;
                }
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                if (message.base != null && message.hasOwnProperty("base"))
                    object.base = message.base;
                if (message.position != null && message.hasOwnProperty("position"))
                    object.position = message.position;
                if (message.rotation != null && message.hasOwnProperty("rotation"))
                    object.rotation = message.rotation;
                if (message.offsetX != null && message.hasOwnProperty("offsetX"))
                    object.offsetX = message.offsetX;
                if (message.offsetY != null && message.hasOwnProperty("offsetY"))
                    object.offsetY = message.offsetY;
                return object;
            };

            /**
             * Converts this SetScreenPosition to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetScreenPosition
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetScreenPosition.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetScreenPosition
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetScreenPosition
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetScreenPosition.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetScreenPosition";
            };

            return SetScreenPosition;
        })();

        protobuf.SetScreenPositionResult = (function() {

            /**
             * Properties of a SetScreenPositionResult.
             * @memberof geelevel.protobuf
             * @interface ISetScreenPositionResult
             * @property {number|null} [secondaryScreenX] SetScreenPositionResult secondaryScreenX
             * @property {number|null} [secondaryScreenY] SetScreenPositionResult secondaryScreenY
             */

            /**
             * Constructs a new SetScreenPositionResult.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetScreenPositionResult.
             * @implements ISetScreenPositionResult
             * @constructor
             * @param {geelevel.protobuf.ISetScreenPositionResult=} [properties] Properties to set
             */
            function SetScreenPositionResult(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetScreenPositionResult secondaryScreenX.
             * @member {number} secondaryScreenX
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @instance
             */
            SetScreenPositionResult.prototype.secondaryScreenX = 0;

            /**
             * SetScreenPositionResult secondaryScreenY.
             * @member {number} secondaryScreenY
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @instance
             */
            SetScreenPositionResult.prototype.secondaryScreenY = 0;

            /**
             * Creates a new SetScreenPositionResult instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @static
             * @param {geelevel.protobuf.ISetScreenPositionResult=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetScreenPositionResult} SetScreenPositionResult instance
             */
            SetScreenPositionResult.create = function create(properties) {
                return new SetScreenPositionResult(properties);
            };

            /**
             * Encodes the specified SetScreenPositionResult message. Does not implicitly {@link geelevel.protobuf.SetScreenPositionResult.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @static
             * @param {geelevel.protobuf.ISetScreenPositionResult} message SetScreenPositionResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetScreenPositionResult.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.secondaryScreenX != null && Object.hasOwnProperty.call(message, "secondaryScreenX"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.secondaryScreenX);
                if (message.secondaryScreenY != null && Object.hasOwnProperty.call(message, "secondaryScreenY"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.secondaryScreenY);
                return writer;
            };

            /**
             * Encodes the specified SetScreenPositionResult message, length delimited. Does not implicitly {@link geelevel.protobuf.SetScreenPositionResult.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @static
             * @param {geelevel.protobuf.ISetScreenPositionResult} message SetScreenPositionResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetScreenPositionResult.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetScreenPositionResult message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetScreenPositionResult} SetScreenPositionResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetScreenPositionResult.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetScreenPositionResult();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.secondaryScreenX = reader.int32();
                            break;
                        }
                    case 2: {
                            message.secondaryScreenY = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetScreenPositionResult message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetScreenPositionResult} SetScreenPositionResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetScreenPositionResult.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetScreenPositionResult message.
             * @function verify
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetScreenPositionResult.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.secondaryScreenX != null && message.hasOwnProperty("secondaryScreenX"))
                    if (!$util.isInteger(message.secondaryScreenX))
                        return "secondaryScreenX: integer expected";
                if (message.secondaryScreenY != null && message.hasOwnProperty("secondaryScreenY"))
                    if (!$util.isInteger(message.secondaryScreenY))
                        return "secondaryScreenY: integer expected";
                return null;
            };

            /**
             * Creates a SetScreenPositionResult message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetScreenPositionResult} SetScreenPositionResult
             */
            SetScreenPositionResult.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetScreenPositionResult)
                    return object;
                var message = new $root.geelevel.protobuf.SetScreenPositionResult();
                if (object.secondaryScreenX != null)
                    message.secondaryScreenX = object.secondaryScreenX | 0;
                if (object.secondaryScreenY != null)
                    message.secondaryScreenY = object.secondaryScreenY | 0;
                return message;
            };

            /**
             * Creates a plain object from a SetScreenPositionResult message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @static
             * @param {geelevel.protobuf.SetScreenPositionResult} message SetScreenPositionResult
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetScreenPositionResult.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.secondaryScreenX = 0;
                    object.secondaryScreenY = 0;
                }
                if (message.secondaryScreenX != null && message.hasOwnProperty("secondaryScreenX"))
                    object.secondaryScreenX = message.secondaryScreenX;
                if (message.secondaryScreenY != null && message.hasOwnProperty("secondaryScreenY"))
                    object.secondaryScreenY = message.secondaryScreenY;
                return object;
            };

            /**
             * Converts this SetScreenPositionResult to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetScreenPositionResult.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetScreenPositionResult
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetScreenPositionResult
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetScreenPositionResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetScreenPositionResult";
            };

            return SetScreenPositionResult;
        })();

        protobuf.RequestKeyFrame = (function() {

            /**
             * Properties of a RequestKeyFrame.
             * @memberof geelevel.protobuf
             * @interface IRequestKeyFrame
             * @property {number|null} [index] RequestKeyFrame index
             */

            /**
             * Constructs a new RequestKeyFrame.
             * @memberof geelevel.protobuf
             * @classdesc Represents a RequestKeyFrame.
             * @implements IRequestKeyFrame
             * @constructor
             * @param {geelevel.protobuf.IRequestKeyFrame=} [properties] Properties to set
             */
            function RequestKeyFrame(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RequestKeyFrame index.
             * @member {number} index
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @instance
             */
            RequestKeyFrame.prototype.index = 0;

            /**
             * Creates a new RequestKeyFrame instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @static
             * @param {geelevel.protobuf.IRequestKeyFrame=} [properties] Properties to set
             * @returns {geelevel.protobuf.RequestKeyFrame} RequestKeyFrame instance
             */
            RequestKeyFrame.create = function create(properties) {
                return new RequestKeyFrame(properties);
            };

            /**
             * Encodes the specified RequestKeyFrame message. Does not implicitly {@link geelevel.protobuf.RequestKeyFrame.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @static
             * @param {geelevel.protobuf.IRequestKeyFrame} message RequestKeyFrame message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RequestKeyFrame.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified RequestKeyFrame message, length delimited. Does not implicitly {@link geelevel.protobuf.RequestKeyFrame.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @static
             * @param {geelevel.protobuf.IRequestKeyFrame} message RequestKeyFrame message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RequestKeyFrame.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RequestKeyFrame message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.RequestKeyFrame} RequestKeyFrame
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RequestKeyFrame.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.RequestKeyFrame();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RequestKeyFrame message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.RequestKeyFrame} RequestKeyFrame
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RequestKeyFrame.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RequestKeyFrame message.
             * @function verify
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RequestKeyFrame.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a RequestKeyFrame message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.RequestKeyFrame} RequestKeyFrame
             */
            RequestKeyFrame.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.RequestKeyFrame)
                    return object;
                var message = new $root.geelevel.protobuf.RequestKeyFrame();
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a RequestKeyFrame message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @static
             * @param {geelevel.protobuf.RequestKeyFrame} message RequestKeyFrame
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RequestKeyFrame.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.index = 0;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this RequestKeyFrame to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RequestKeyFrame.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RequestKeyFrame
             * @function getTypeUrl
             * @memberof geelevel.protobuf.RequestKeyFrame
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RequestKeyFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.RequestKeyFrame";
            };

            return RequestKeyFrame;
        })();

        protobuf.SetVideoBitrate = (function() {

            /**
             * Properties of a SetVideoBitrate.
             * @memberof geelevel.protobuf
             * @interface ISetVideoBitrate
             * @property {geelevel.protobuf.SetVideoBitrate.BitrateType|null} [value] SetVideoBitrate value
             * @property {number|null} [index] SetVideoBitrate index
             * @property {number|null} [minBitrate] SetVideoBitrate minBitrate
             * @property {number|null} [maxBitrate] SetVideoBitrate maxBitrate
             * @property {number|null} [averageBitrate] SetVideoBitrate averageBitrate
             */

            /**
             * Constructs a new SetVideoBitrate.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetVideoBitrate.
             * @implements ISetVideoBitrate
             * @constructor
             * @param {geelevel.protobuf.ISetVideoBitrate=} [properties] Properties to set
             */
            function SetVideoBitrate(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetVideoBitrate value.
             * @member {geelevel.protobuf.SetVideoBitrate.BitrateType} value
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @instance
             */
            SetVideoBitrate.prototype.value = 0;

            /**
             * SetVideoBitrate index.
             * @member {number} index
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @instance
             */
            SetVideoBitrate.prototype.index = 0;

            /**
             * SetVideoBitrate minBitrate.
             * @member {number} minBitrate
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @instance
             */
            SetVideoBitrate.prototype.minBitrate = 0;

            /**
             * SetVideoBitrate maxBitrate.
             * @member {number} maxBitrate
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @instance
             */
            SetVideoBitrate.prototype.maxBitrate = 0;

            /**
             * SetVideoBitrate averageBitrate.
             * @member {number} averageBitrate
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @instance
             */
            SetVideoBitrate.prototype.averageBitrate = 0;

            /**
             * Creates a new SetVideoBitrate instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @static
             * @param {geelevel.protobuf.ISetVideoBitrate=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetVideoBitrate} SetVideoBitrate instance
             */
            SetVideoBitrate.create = function create(properties) {
                return new SetVideoBitrate(properties);
            };

            /**
             * Encodes the specified SetVideoBitrate message. Does not implicitly {@link geelevel.protobuf.SetVideoBitrate.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @static
             * @param {geelevel.protobuf.ISetVideoBitrate} message SetVideoBitrate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoBitrate.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.index);
                if (message.minBitrate != null && Object.hasOwnProperty.call(message, "minBitrate"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.minBitrate);
                if (message.maxBitrate != null && Object.hasOwnProperty.call(message, "maxBitrate"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.maxBitrate);
                if (message.averageBitrate != null && Object.hasOwnProperty.call(message, "averageBitrate"))
                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.averageBitrate);
                return writer;
            };

            /**
             * Encodes the specified SetVideoBitrate message, length delimited. Does not implicitly {@link geelevel.protobuf.SetVideoBitrate.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @static
             * @param {geelevel.protobuf.ISetVideoBitrate} message SetVideoBitrate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoBitrate.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetVideoBitrate message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetVideoBitrate} SetVideoBitrate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoBitrate.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetVideoBitrate();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.value = reader.int32();
                            break;
                        }
                    case 2: {
                            message.index = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.minBitrate = reader.uint32();
                            break;
                        }
                    case 4: {
                            message.maxBitrate = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.averageBitrate = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetVideoBitrate message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetVideoBitrate} SetVideoBitrate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoBitrate.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetVideoBitrate message.
             * @function verify
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetVideoBitrate.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    switch (message.value) {
                    default:
                        return "value: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                if (message.minBitrate != null && message.hasOwnProperty("minBitrate"))
                    if (!$util.isInteger(message.minBitrate))
                        return "minBitrate: integer expected";
                if (message.maxBitrate != null && message.hasOwnProperty("maxBitrate"))
                    if (!$util.isInteger(message.maxBitrate))
                        return "maxBitrate: integer expected";
                if (message.averageBitrate != null && message.hasOwnProperty("averageBitrate"))
                    if (!$util.isInteger(message.averageBitrate))
                        return "averageBitrate: integer expected";
                return null;
            };

            /**
             * Creates a SetVideoBitrate message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetVideoBitrate} SetVideoBitrate
             */
            SetVideoBitrate.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetVideoBitrate)
                    return object;
                var message = new $root.geelevel.protobuf.SetVideoBitrate();
                switch (object.value) {
                default:
                    if (typeof object.value === "number") {
                        message.value = object.value;
                        break;
                    }
                    break;
                case "AUTO":
                case 0:
                    message.value = 0;
                    break;
                case "SPEED":
                case 1:
                    message.value = 1;
                    break;
                case "QUALITY":
                case 2:
                    message.value = 2;
                    break;
                }
                if (object.index != null)
                    message.index = object.index >>> 0;
                if (object.minBitrate != null)
                    message.minBitrate = object.minBitrate >>> 0;
                if (object.maxBitrate != null)
                    message.maxBitrate = object.maxBitrate >>> 0;
                if (object.averageBitrate != null)
                    message.averageBitrate = object.averageBitrate >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SetVideoBitrate message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @static
             * @param {geelevel.protobuf.SetVideoBitrate} message SetVideoBitrate
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetVideoBitrate.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.value = options.enums === String ? "AUTO" : 0;
                    object.index = 0;
                    object.minBitrate = 0;
                    object.maxBitrate = 0;
                    object.averageBitrate = 0;
                }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.enums === String ? $root.geelevel.protobuf.SetVideoBitrate.BitrateType[message.value] === undefined ? message.value : $root.geelevel.protobuf.SetVideoBitrate.BitrateType[message.value] : message.value;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                if (message.minBitrate != null && message.hasOwnProperty("minBitrate"))
                    object.minBitrate = message.minBitrate;
                if (message.maxBitrate != null && message.hasOwnProperty("maxBitrate"))
                    object.maxBitrate = message.maxBitrate;
                if (message.averageBitrate != null && message.hasOwnProperty("averageBitrate"))
                    object.averageBitrate = message.averageBitrate;
                return object;
            };

            /**
             * Converts this SetVideoBitrate to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetVideoBitrate.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetVideoBitrate
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetVideoBitrate
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetVideoBitrate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetVideoBitrate";
            };

            /**
             * BitrateType enum.
             * @name geelevel.protobuf.SetVideoBitrate.BitrateType
             * @enum {number}
             * @property {number} AUTO=0 AUTO value
             * @property {number} SPEED=1 SPEED value
             * @property {number} QUALITY=2 QUALITY value
             */
            SetVideoBitrate.BitrateType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "AUTO"] = 0;
                values[valuesById[1] = "SPEED"] = 1;
                values[valuesById[2] = "QUALITY"] = 2;
                return values;
            })();

            return SetVideoBitrate;
        })();

        protobuf.SetVideoContent = (function() {

            /**
             * Properties of a SetVideoContent.
             * @memberof geelevel.protobuf
             * @interface ISetVideoContent
             * @property {geelevel.protobuf.SetVideoContent.ContentHint|null} [value] SetVideoContent value
             * @property {number|null} [index] SetVideoContent index
             */

            /**
             * Constructs a new SetVideoContent.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetVideoContent.
             * @implements ISetVideoContent
             * @constructor
             * @param {geelevel.protobuf.ISetVideoContent=} [properties] Properties to set
             */
            function SetVideoContent(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetVideoContent value.
             * @member {geelevel.protobuf.SetVideoContent.ContentHint} value
             * @memberof geelevel.protobuf.SetVideoContent
             * @instance
             */
            SetVideoContent.prototype.value = 0;

            /**
             * SetVideoContent index.
             * @member {number} index
             * @memberof geelevel.protobuf.SetVideoContent
             * @instance
             */
            SetVideoContent.prototype.index = 0;

            /**
             * Creates a new SetVideoContent instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetVideoContent
             * @static
             * @param {geelevel.protobuf.ISetVideoContent=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetVideoContent} SetVideoContent instance
             */
            SetVideoContent.create = function create(properties) {
                return new SetVideoContent(properties);
            };

            /**
             * Encodes the specified SetVideoContent message. Does not implicitly {@link geelevel.protobuf.SetVideoContent.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetVideoContent
             * @static
             * @param {geelevel.protobuf.ISetVideoContent} message SetVideoContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoContent.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified SetVideoContent message, length delimited. Does not implicitly {@link geelevel.protobuf.SetVideoContent.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetVideoContent
             * @static
             * @param {geelevel.protobuf.ISetVideoContent} message SetVideoContent message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoContent.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetVideoContent message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetVideoContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetVideoContent} SetVideoContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoContent.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetVideoContent();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.value = reader.int32();
                            break;
                        }
                    case 2: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetVideoContent message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetVideoContent
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetVideoContent} SetVideoContent
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoContent.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetVideoContent message.
             * @function verify
             * @memberof geelevel.protobuf.SetVideoContent
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetVideoContent.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    switch (message.value) {
                    default:
                        return "value: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a SetVideoContent message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetVideoContent
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetVideoContent} SetVideoContent
             */
            SetVideoContent.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetVideoContent)
                    return object;
                var message = new $root.geelevel.protobuf.SetVideoContent();
                switch (object.value) {
                default:
                    if (typeof object.value === "number") {
                        message.value = object.value;
                        break;
                    }
                    break;
                case "NONE":
                case 0:
                    message.value = 0;
                    break;
                case "FLUID":
                case 1:
                    message.value = 1;
                    break;
                case "DETAILED":
                case 2:
                    message.value = 2;
                    break;
                case "TEXT":
                case 3:
                    message.value = 3;
                    break;
                }
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SetVideoContent message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetVideoContent
             * @static
             * @param {geelevel.protobuf.SetVideoContent} message SetVideoContent
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetVideoContent.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.value = options.enums === String ? "NONE" : 0;
                    object.index = 0;
                }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.enums === String ? $root.geelevel.protobuf.SetVideoContent.ContentHint[message.value] === undefined ? message.value : $root.geelevel.protobuf.SetVideoContent.ContentHint[message.value] : message.value;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this SetVideoContent to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetVideoContent
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetVideoContent.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetVideoContent
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetVideoContent
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetVideoContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetVideoContent";
            };

            /**
             * ContentHint enum.
             * @name geelevel.protobuf.SetVideoContent.ContentHint
             * @enum {number}
             * @property {number} NONE=0 NONE value
             * @property {number} FLUID=1 FLUID value
             * @property {number} DETAILED=2 DETAILED value
             * @property {number} TEXT=3 TEXT value
             */
            SetVideoContent.ContentHint = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "NONE"] = 0;
                values[valuesById[1] = "FLUID"] = 1;
                values[valuesById[2] = "DETAILED"] = 2;
                values[valuesById[3] = "TEXT"] = 3;
                return values;
            })();

            return SetVideoContent;
        })();

        protobuf.SetVideoFps = (function() {

            /**
             * Properties of a SetVideoFps.
             * @memberof geelevel.protobuf
             * @interface ISetVideoFps
             * @property {number|null} [fps] SetVideoFps fps
             * @property {number|null} [index] SetVideoFps index
             * @property {number|null} [maxFps] SetVideoFps maxFps
             * @property {boolean|null} [isDynamicFps] SetVideoFps isDynamicFps
             */

            /**
             * Constructs a new SetVideoFps.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetVideoFps.
             * @implements ISetVideoFps
             * @constructor
             * @param {geelevel.protobuf.ISetVideoFps=} [properties] Properties to set
             */
            function SetVideoFps(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetVideoFps fps.
             * @member {number} fps
             * @memberof geelevel.protobuf.SetVideoFps
             * @instance
             */
            SetVideoFps.prototype.fps = 0;

            /**
             * SetVideoFps index.
             * @member {number} index
             * @memberof geelevel.protobuf.SetVideoFps
             * @instance
             */
            SetVideoFps.prototype.index = 0;

            /**
             * SetVideoFps maxFps.
             * @member {number} maxFps
             * @memberof geelevel.protobuf.SetVideoFps
             * @instance
             */
            SetVideoFps.prototype.maxFps = 0;

            /**
             * SetVideoFps isDynamicFps.
             * @member {boolean} isDynamicFps
             * @memberof geelevel.protobuf.SetVideoFps
             * @instance
             */
            SetVideoFps.prototype.isDynamicFps = false;

            /**
             * Creates a new SetVideoFps instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetVideoFps
             * @static
             * @param {geelevel.protobuf.ISetVideoFps=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetVideoFps} SetVideoFps instance
             */
            SetVideoFps.create = function create(properties) {
                return new SetVideoFps(properties);
            };

            /**
             * Encodes the specified SetVideoFps message. Does not implicitly {@link geelevel.protobuf.SetVideoFps.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetVideoFps
             * @static
             * @param {geelevel.protobuf.ISetVideoFps} message SetVideoFps message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoFps.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.fps != null && Object.hasOwnProperty.call(message, "fps"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.fps);
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.index);
                if (message.maxFps != null && Object.hasOwnProperty.call(message, "maxFps"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.maxFps);
                if (message.isDynamicFps != null && Object.hasOwnProperty.call(message, "isDynamicFps"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isDynamicFps);
                return writer;
            };

            /**
             * Encodes the specified SetVideoFps message, length delimited. Does not implicitly {@link geelevel.protobuf.SetVideoFps.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetVideoFps
             * @static
             * @param {geelevel.protobuf.ISetVideoFps} message SetVideoFps message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoFps.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetVideoFps message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetVideoFps
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetVideoFps} SetVideoFps
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoFps.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetVideoFps();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.fps = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.index = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.maxFps = reader.uint32();
                            break;
                        }
                    case 4: {
                            message.isDynamicFps = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetVideoFps message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetVideoFps
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetVideoFps} SetVideoFps
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoFps.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetVideoFps message.
             * @function verify
             * @memberof geelevel.protobuf.SetVideoFps
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetVideoFps.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.fps != null && message.hasOwnProperty("fps"))
                    if (!$util.isInteger(message.fps))
                        return "fps: integer expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                if (message.maxFps != null && message.hasOwnProperty("maxFps"))
                    if (!$util.isInteger(message.maxFps))
                        return "maxFps: integer expected";
                if (message.isDynamicFps != null && message.hasOwnProperty("isDynamicFps"))
                    if (typeof message.isDynamicFps !== "boolean")
                        return "isDynamicFps: boolean expected";
                return null;
            };

            /**
             * Creates a SetVideoFps message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetVideoFps
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetVideoFps} SetVideoFps
             */
            SetVideoFps.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetVideoFps)
                    return object;
                var message = new $root.geelevel.protobuf.SetVideoFps();
                if (object.fps != null)
                    message.fps = object.fps >>> 0;
                if (object.index != null)
                    message.index = object.index >>> 0;
                if (object.maxFps != null)
                    message.maxFps = object.maxFps >>> 0;
                if (object.isDynamicFps != null)
                    message.isDynamicFps = Boolean(object.isDynamicFps);
                return message;
            };

            /**
             * Creates a plain object from a SetVideoFps message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetVideoFps
             * @static
             * @param {geelevel.protobuf.SetVideoFps} message SetVideoFps
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetVideoFps.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.fps = 0;
                    object.index = 0;
                    object.maxFps = 0;
                    object.isDynamicFps = false;
                }
                if (message.fps != null && message.hasOwnProperty("fps"))
                    object.fps = message.fps;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                if (message.maxFps != null && message.hasOwnProperty("maxFps"))
                    object.maxFps = message.maxFps;
                if (message.isDynamicFps != null && message.hasOwnProperty("isDynamicFps"))
                    object.isDynamicFps = message.isDynamicFps;
                return object;
            };

            /**
             * Converts this SetVideoFps to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetVideoFps
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetVideoFps.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetVideoFps
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetVideoFps
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetVideoFps.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetVideoFps";
            };

            return SetVideoFps;
        })();

        protobuf.SetVideoHardwareAccelerated = (function() {

            /**
             * Properties of a SetVideoHardwareAccelerated.
             * @memberof geelevel.protobuf
             * @interface ISetVideoHardwareAccelerated
             * @property {boolean|null} [enable] SetVideoHardwareAccelerated enable
             */

            /**
             * Constructs a new SetVideoHardwareAccelerated.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetVideoHardwareAccelerated.
             * @implements ISetVideoHardwareAccelerated
             * @constructor
             * @param {geelevel.protobuf.ISetVideoHardwareAccelerated=} [properties] Properties to set
             */
            function SetVideoHardwareAccelerated(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetVideoHardwareAccelerated enable.
             * @member {boolean} enable
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @instance
             */
            SetVideoHardwareAccelerated.prototype.enable = false;

            /**
             * Creates a new SetVideoHardwareAccelerated instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @static
             * @param {geelevel.protobuf.ISetVideoHardwareAccelerated=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetVideoHardwareAccelerated} SetVideoHardwareAccelerated instance
             */
            SetVideoHardwareAccelerated.create = function create(properties) {
                return new SetVideoHardwareAccelerated(properties);
            };

            /**
             * Encodes the specified SetVideoHardwareAccelerated message. Does not implicitly {@link geelevel.protobuf.SetVideoHardwareAccelerated.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @static
             * @param {geelevel.protobuf.ISetVideoHardwareAccelerated} message SetVideoHardwareAccelerated message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoHardwareAccelerated.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.enable != null && Object.hasOwnProperty.call(message, "enable"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enable);
                return writer;
            };

            /**
             * Encodes the specified SetVideoHardwareAccelerated message, length delimited. Does not implicitly {@link geelevel.protobuf.SetVideoHardwareAccelerated.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @static
             * @param {geelevel.protobuf.ISetVideoHardwareAccelerated} message SetVideoHardwareAccelerated message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVideoHardwareAccelerated.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetVideoHardwareAccelerated message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetVideoHardwareAccelerated} SetVideoHardwareAccelerated
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoHardwareAccelerated.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetVideoHardwareAccelerated();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.enable = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetVideoHardwareAccelerated message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetVideoHardwareAccelerated} SetVideoHardwareAccelerated
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVideoHardwareAccelerated.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetVideoHardwareAccelerated message.
             * @function verify
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetVideoHardwareAccelerated.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.enable != null && message.hasOwnProperty("enable"))
                    if (typeof message.enable !== "boolean")
                        return "enable: boolean expected";
                return null;
            };

            /**
             * Creates a SetVideoHardwareAccelerated message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetVideoHardwareAccelerated} SetVideoHardwareAccelerated
             */
            SetVideoHardwareAccelerated.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetVideoHardwareAccelerated)
                    return object;
                var message = new $root.geelevel.protobuf.SetVideoHardwareAccelerated();
                if (object.enable != null)
                    message.enable = Boolean(object.enable);
                return message;
            };

            /**
             * Creates a plain object from a SetVideoHardwareAccelerated message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @static
             * @param {geelevel.protobuf.SetVideoHardwareAccelerated} message SetVideoHardwareAccelerated
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetVideoHardwareAccelerated.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.enable = false;
                if (message.enable != null && message.hasOwnProperty("enable"))
                    object.enable = message.enable;
                return object;
            };

            /**
             * Converts this SetVideoHardwareAccelerated to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetVideoHardwareAccelerated.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetVideoHardwareAccelerated
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetVideoHardwareAccelerated
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetVideoHardwareAccelerated.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetVideoHardwareAccelerated";
            };

            return SetVideoHardwareAccelerated;
        })();

        protobuf.EnableAudio = (function() {

            /**
             * Properties of an EnableAudio.
             * @memberof geelevel.protobuf
             * @interface IEnableAudio
             * @property {boolean|null} [enable] EnableAudio enable
             */

            /**
             * Constructs a new EnableAudio.
             * @memberof geelevel.protobuf
             * @classdesc Represents an EnableAudio.
             * @implements IEnableAudio
             * @constructor
             * @param {geelevel.protobuf.IEnableAudio=} [properties] Properties to set
             */
            function EnableAudio(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EnableAudio enable.
             * @member {boolean} enable
             * @memberof geelevel.protobuf.EnableAudio
             * @instance
             */
            EnableAudio.prototype.enable = false;

            /**
             * Creates a new EnableAudio instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.EnableAudio
             * @static
             * @param {geelevel.protobuf.IEnableAudio=} [properties] Properties to set
             * @returns {geelevel.protobuf.EnableAudio} EnableAudio instance
             */
            EnableAudio.create = function create(properties) {
                return new EnableAudio(properties);
            };

            /**
             * Encodes the specified EnableAudio message. Does not implicitly {@link geelevel.protobuf.EnableAudio.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.EnableAudio
             * @static
             * @param {geelevel.protobuf.IEnableAudio} message EnableAudio message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnableAudio.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.enable != null && Object.hasOwnProperty.call(message, "enable"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enable);
                return writer;
            };

            /**
             * Encodes the specified EnableAudio message, length delimited. Does not implicitly {@link geelevel.protobuf.EnableAudio.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.EnableAudio
             * @static
             * @param {geelevel.protobuf.IEnableAudio} message EnableAudio message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnableAudio.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EnableAudio message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.EnableAudio
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.EnableAudio} EnableAudio
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnableAudio.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.EnableAudio();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.enable = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EnableAudio message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.EnableAudio
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.EnableAudio} EnableAudio
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnableAudio.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EnableAudio message.
             * @function verify
             * @memberof geelevel.protobuf.EnableAudio
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EnableAudio.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.enable != null && message.hasOwnProperty("enable"))
                    if (typeof message.enable !== "boolean")
                        return "enable: boolean expected";
                return null;
            };

            /**
             * Creates an EnableAudio message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.EnableAudio
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.EnableAudio} EnableAudio
             */
            EnableAudio.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.EnableAudio)
                    return object;
                var message = new $root.geelevel.protobuf.EnableAudio();
                if (object.enable != null)
                    message.enable = Boolean(object.enable);
                return message;
            };

            /**
             * Creates a plain object from an EnableAudio message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.EnableAudio
             * @static
             * @param {geelevel.protobuf.EnableAudio} message EnableAudio
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EnableAudio.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.enable = false;
                if (message.enable != null && message.hasOwnProperty("enable"))
                    object.enable = message.enable;
                return object;
            };

            /**
             * Converts this EnableAudio to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.EnableAudio
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EnableAudio.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EnableAudio
             * @function getTypeUrl
             * @memberof geelevel.protobuf.EnableAudio
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EnableAudio.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.EnableAudio";
            };

            return EnableAudio;
        })();

        protobuf.EnableTalk = (function() {

            /**
             * Properties of an EnableTalk.
             * @memberof geelevel.protobuf
             * @interface IEnableTalk
             * @property {boolean|null} [enable] EnableTalk enable
             */

            /**
             * Constructs a new EnableTalk.
             * @memberof geelevel.protobuf
             * @classdesc Represents an EnableTalk.
             * @implements IEnableTalk
             * @constructor
             * @param {geelevel.protobuf.IEnableTalk=} [properties] Properties to set
             */
            function EnableTalk(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EnableTalk enable.
             * @member {boolean} enable
             * @memberof geelevel.protobuf.EnableTalk
             * @instance
             */
            EnableTalk.prototype.enable = false;

            /**
             * Creates a new EnableTalk instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.EnableTalk
             * @static
             * @param {geelevel.protobuf.IEnableTalk=} [properties] Properties to set
             * @returns {geelevel.protobuf.EnableTalk} EnableTalk instance
             */
            EnableTalk.create = function create(properties) {
                return new EnableTalk(properties);
            };

            /**
             * Encodes the specified EnableTalk message. Does not implicitly {@link geelevel.protobuf.EnableTalk.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.EnableTalk
             * @static
             * @param {geelevel.protobuf.IEnableTalk} message EnableTalk message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnableTalk.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.enable != null && Object.hasOwnProperty.call(message, "enable"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enable);
                return writer;
            };

            /**
             * Encodes the specified EnableTalk message, length delimited. Does not implicitly {@link geelevel.protobuf.EnableTalk.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.EnableTalk
             * @static
             * @param {geelevel.protobuf.IEnableTalk} message EnableTalk message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnableTalk.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EnableTalk message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.EnableTalk
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.EnableTalk} EnableTalk
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnableTalk.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.EnableTalk();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.enable = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EnableTalk message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.EnableTalk
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.EnableTalk} EnableTalk
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnableTalk.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EnableTalk message.
             * @function verify
             * @memberof geelevel.protobuf.EnableTalk
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EnableTalk.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.enable != null && message.hasOwnProperty("enable"))
                    if (typeof message.enable !== "boolean")
                        return "enable: boolean expected";
                return null;
            };

            /**
             * Creates an EnableTalk message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.EnableTalk
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.EnableTalk} EnableTalk
             */
            EnableTalk.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.EnableTalk)
                    return object;
                var message = new $root.geelevel.protobuf.EnableTalk();
                if (object.enable != null)
                    message.enable = Boolean(object.enable);
                return message;
            };

            /**
             * Creates a plain object from an EnableTalk message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.EnableTalk
             * @static
             * @param {geelevel.protobuf.EnableTalk} message EnableTalk
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EnableTalk.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.enable = false;
                if (message.enable != null && message.hasOwnProperty("enable"))
                    object.enable = message.enable;
                return object;
            };

            /**
             * Converts this EnableTalk to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.EnableTalk
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EnableTalk.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for EnableTalk
             * @function getTypeUrl
             * @memberof geelevel.protobuf.EnableTalk
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            EnableTalk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.EnableTalk";
            };

            return EnableTalk;
        })();

        protobuf.SwitchVideoSource = (function() {

            /**
             * Properties of a SwitchVideoSource.
             * @memberof geelevel.protobuf
             * @interface ISwitchVideoSource
             * @property {number|null} [index] SwitchVideoSource index
             */

            /**
             * Constructs a new SwitchVideoSource.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SwitchVideoSource.
             * @implements ISwitchVideoSource
             * @constructor
             * @param {geelevel.protobuf.ISwitchVideoSource=} [properties] Properties to set
             */
            function SwitchVideoSource(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SwitchVideoSource index.
             * @member {number} index
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @instance
             */
            SwitchVideoSource.prototype.index = 0;

            /**
             * Creates a new SwitchVideoSource instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @static
             * @param {geelevel.protobuf.ISwitchVideoSource=} [properties] Properties to set
             * @returns {geelevel.protobuf.SwitchVideoSource} SwitchVideoSource instance
             */
            SwitchVideoSource.create = function create(properties) {
                return new SwitchVideoSource(properties);
            };

            /**
             * Encodes the specified SwitchVideoSource message. Does not implicitly {@link geelevel.protobuf.SwitchVideoSource.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @static
             * @param {geelevel.protobuf.ISwitchVideoSource} message SwitchVideoSource message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SwitchVideoSource.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified SwitchVideoSource message, length delimited. Does not implicitly {@link geelevel.protobuf.SwitchVideoSource.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @static
             * @param {geelevel.protobuf.ISwitchVideoSource} message SwitchVideoSource message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SwitchVideoSource.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SwitchVideoSource message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SwitchVideoSource} SwitchVideoSource
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SwitchVideoSource.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SwitchVideoSource();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SwitchVideoSource message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SwitchVideoSource} SwitchVideoSource
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SwitchVideoSource.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SwitchVideoSource message.
             * @function verify
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SwitchVideoSource.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a SwitchVideoSource message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SwitchVideoSource} SwitchVideoSource
             */
            SwitchVideoSource.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SwitchVideoSource)
                    return object;
                var message = new $root.geelevel.protobuf.SwitchVideoSource();
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SwitchVideoSource message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @static
             * @param {geelevel.protobuf.SwitchVideoSource} message SwitchVideoSource
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SwitchVideoSource.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.index = 0;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this SwitchVideoSource to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SwitchVideoSource.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SwitchVideoSource
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SwitchVideoSource
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SwitchVideoSource.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SwitchVideoSource";
            };

            return SwitchVideoSource;
        })();

        protobuf.SetPrivacyScreen = (function() {

            /**
             * Properties of a SetPrivacyScreen.
             * @memberof geelevel.protobuf
             * @interface ISetPrivacyScreen
             * @property {boolean|null} [enable] SetPrivacyScreen enable
             * @property {number|null} [type] SetPrivacyScreen type
             */

            /**
             * Constructs a new SetPrivacyScreen.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetPrivacyScreen.
             * @implements ISetPrivacyScreen
             * @constructor
             * @param {geelevel.protobuf.ISetPrivacyScreen=} [properties] Properties to set
             */
            function SetPrivacyScreen(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetPrivacyScreen enable.
             * @member {boolean} enable
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @instance
             */
            SetPrivacyScreen.prototype.enable = false;

            /**
             * SetPrivacyScreen type.
             * @member {number} type
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @instance
             */
            SetPrivacyScreen.prototype.type = 0;

            /**
             * Creates a new SetPrivacyScreen instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @static
             * @param {geelevel.protobuf.ISetPrivacyScreen=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetPrivacyScreen} SetPrivacyScreen instance
             */
            SetPrivacyScreen.create = function create(properties) {
                return new SetPrivacyScreen(properties);
            };

            /**
             * Encodes the specified SetPrivacyScreen message. Does not implicitly {@link geelevel.protobuf.SetPrivacyScreen.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @static
             * @param {geelevel.protobuf.ISetPrivacyScreen} message SetPrivacyScreen message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetPrivacyScreen.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.enable != null && Object.hasOwnProperty.call(message, "enable"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enable);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.type);
                return writer;
            };

            /**
             * Encodes the specified SetPrivacyScreen message, length delimited. Does not implicitly {@link geelevel.protobuf.SetPrivacyScreen.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @static
             * @param {geelevel.protobuf.ISetPrivacyScreen} message SetPrivacyScreen message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetPrivacyScreen.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetPrivacyScreen message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetPrivacyScreen} SetPrivacyScreen
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetPrivacyScreen.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetPrivacyScreen();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.enable = reader.bool();
                            break;
                        }
                    case 2: {
                            message.type = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetPrivacyScreen message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetPrivacyScreen} SetPrivacyScreen
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetPrivacyScreen.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetPrivacyScreen message.
             * @function verify
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetPrivacyScreen.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.enable != null && message.hasOwnProperty("enable"))
                    if (typeof message.enable !== "boolean")
                        return "enable: boolean expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                return null;
            };

            /**
             * Creates a SetPrivacyScreen message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetPrivacyScreen} SetPrivacyScreen
             */
            SetPrivacyScreen.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetPrivacyScreen)
                    return object;
                var message = new $root.geelevel.protobuf.SetPrivacyScreen();
                if (object.enable != null)
                    message.enable = Boolean(object.enable);
                if (object.type != null)
                    message.type = object.type >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SetPrivacyScreen message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @static
             * @param {geelevel.protobuf.SetPrivacyScreen} message SetPrivacyScreen
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetPrivacyScreen.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.enable = false;
                    object.type = 0;
                }
                if (message.enable != null && message.hasOwnProperty("enable"))
                    object.enable = message.enable;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                return object;
            };

            /**
             * Converts this SetPrivacyScreen to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetPrivacyScreen.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetPrivacyScreen
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetPrivacyScreen
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetPrivacyScreen.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetPrivacyScreen";
            };

            return SetPrivacyScreen;
        })();

        protobuf.SyncPrivacyScreen = (function() {

            /**
             * Properties of a SyncPrivacyScreen.
             * @memberof geelevel.protobuf
             * @interface ISyncPrivacyScreen
             * @property {boolean|null} [enable] SyncPrivacyScreen enable
             * @property {number|null} [type] SyncPrivacyScreen type
             */

            /**
             * Constructs a new SyncPrivacyScreen.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SyncPrivacyScreen.
             * @implements ISyncPrivacyScreen
             * @constructor
             * @param {geelevel.protobuf.ISyncPrivacyScreen=} [properties] Properties to set
             */
            function SyncPrivacyScreen(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SyncPrivacyScreen enable.
             * @member {boolean} enable
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @instance
             */
            SyncPrivacyScreen.prototype.enable = false;

            /**
             * SyncPrivacyScreen type.
             * @member {number} type
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @instance
             */
            SyncPrivacyScreen.prototype.type = 0;

            /**
             * Creates a new SyncPrivacyScreen instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @static
             * @param {geelevel.protobuf.ISyncPrivacyScreen=} [properties] Properties to set
             * @returns {geelevel.protobuf.SyncPrivacyScreen} SyncPrivacyScreen instance
             */
            SyncPrivacyScreen.create = function create(properties) {
                return new SyncPrivacyScreen(properties);
            };

            /**
             * Encodes the specified SyncPrivacyScreen message. Does not implicitly {@link geelevel.protobuf.SyncPrivacyScreen.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @static
             * @param {geelevel.protobuf.ISyncPrivacyScreen} message SyncPrivacyScreen message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SyncPrivacyScreen.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.enable != null && Object.hasOwnProperty.call(message, "enable"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enable);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.type);
                return writer;
            };

            /**
             * Encodes the specified SyncPrivacyScreen message, length delimited. Does not implicitly {@link geelevel.protobuf.SyncPrivacyScreen.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @static
             * @param {geelevel.protobuf.ISyncPrivacyScreen} message SyncPrivacyScreen message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SyncPrivacyScreen.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SyncPrivacyScreen message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SyncPrivacyScreen} SyncPrivacyScreen
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SyncPrivacyScreen.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SyncPrivacyScreen();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.enable = reader.bool();
                            break;
                        }
                    case 2: {
                            message.type = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SyncPrivacyScreen message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SyncPrivacyScreen} SyncPrivacyScreen
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SyncPrivacyScreen.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SyncPrivacyScreen message.
             * @function verify
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SyncPrivacyScreen.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.enable != null && message.hasOwnProperty("enable"))
                    if (typeof message.enable !== "boolean")
                        return "enable: boolean expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                return null;
            };

            /**
             * Creates a SyncPrivacyScreen message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SyncPrivacyScreen} SyncPrivacyScreen
             */
            SyncPrivacyScreen.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SyncPrivacyScreen)
                    return object;
                var message = new $root.geelevel.protobuf.SyncPrivacyScreen();
                if (object.enable != null)
                    message.enable = Boolean(object.enable);
                if (object.type != null)
                    message.type = object.type >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SyncPrivacyScreen message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @static
             * @param {geelevel.protobuf.SyncPrivacyScreen} message SyncPrivacyScreen
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SyncPrivacyScreen.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.enable = false;
                    object.type = 0;
                }
                if (message.enable != null && message.hasOwnProperty("enable"))
                    object.enable = message.enable;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                return object;
            };

            /**
             * Converts this SyncPrivacyScreen to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SyncPrivacyScreen.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SyncPrivacyScreen
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SyncPrivacyScreen
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SyncPrivacyScreen.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SyncPrivacyScreen";
            };

            return SyncPrivacyScreen;
        })();

        protobuf.ReplayResult = (function() {

            /**
             * Properties of a ReplayResult.
             * @memberof geelevel.protobuf
             * @interface IReplayResult
             * @property {number|null} [code] ReplayResult code
             * @property {number|null} [result] ReplayResult result
             * @property {Uint8Array|null} [data] ReplayResult data
             */

            /**
             * Constructs a new ReplayResult.
             * @memberof geelevel.protobuf
             * @classdesc Represents a ReplayResult.
             * @implements IReplayResult
             * @constructor
             * @param {geelevel.protobuf.IReplayResult=} [properties] Properties to set
             */
            function ReplayResult(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReplayResult code.
             * @member {number} code
             * @memberof geelevel.protobuf.ReplayResult
             * @instance
             */
            ReplayResult.prototype.code = 0;

            /**
             * ReplayResult result.
             * @member {number} result
             * @memberof geelevel.protobuf.ReplayResult
             * @instance
             */
            ReplayResult.prototype.result = 0;

            /**
             * ReplayResult data.
             * @member {Uint8Array} data
             * @memberof geelevel.protobuf.ReplayResult
             * @instance
             */
            ReplayResult.prototype.data = $util.newBuffer([]);

            /**
             * Creates a new ReplayResult instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.ReplayResult
             * @static
             * @param {geelevel.protobuf.IReplayResult=} [properties] Properties to set
             * @returns {geelevel.protobuf.ReplayResult} ReplayResult instance
             */
            ReplayResult.create = function create(properties) {
                return new ReplayResult(properties);
            };

            /**
             * Encodes the specified ReplayResult message. Does not implicitly {@link geelevel.protobuf.ReplayResult.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.ReplayResult
             * @static
             * @param {geelevel.protobuf.IReplayResult} message ReplayResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReplayResult.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.result);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.data);
                return writer;
            };

            /**
             * Encodes the specified ReplayResult message, length delimited. Does not implicitly {@link geelevel.protobuf.ReplayResult.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.ReplayResult
             * @static
             * @param {geelevel.protobuf.IReplayResult} message ReplayResult message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReplayResult.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReplayResult message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.ReplayResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.ReplayResult} ReplayResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReplayResult.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.ReplayResult();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.code = reader.int32();
                            break;
                        }
                    case 2: {
                            message.result = reader.int32();
                            break;
                        }
                    case 3: {
                            message.data = reader.bytes();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReplayResult message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.ReplayResult
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.ReplayResult} ReplayResult
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReplayResult.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReplayResult message.
             * @function verify
             * @memberof geelevel.protobuf.ReplayResult
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReplayResult.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isInteger(message.code))
                        return "code: integer expected";
                if (message.result != null && message.hasOwnProperty("result"))
                    if (!$util.isInteger(message.result))
                        return "result: integer expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                        return "data: buffer expected";
                return null;
            };

            /**
             * Creates a ReplayResult message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.ReplayResult
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.ReplayResult} ReplayResult
             */
            ReplayResult.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.ReplayResult)
                    return object;
                var message = new $root.geelevel.protobuf.ReplayResult();
                if (object.code != null)
                    message.code = object.code | 0;
                if (object.result != null)
                    message.result = object.result | 0;
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length >= 0)
                        message.data = object.data;
                return message;
            };

            /**
             * Creates a plain object from a ReplayResult message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.ReplayResult
             * @static
             * @param {geelevel.protobuf.ReplayResult} message ReplayResult
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReplayResult.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.code = 0;
                    object.result = 0;
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                }
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.result != null && message.hasOwnProperty("result"))
                    object.result = message.result;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                return object;
            };

            /**
             * Converts this ReplayResult to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.ReplayResult
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReplayResult.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ReplayResult
             * @function getTypeUrl
             * @memberof geelevel.protobuf.ReplayResult
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ReplayResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.ReplayResult";
            };

            return ReplayResult;
        })();

        protobuf.SetShowRemoteCursor = (function() {

            /**
             * Properties of a SetShowRemoteCursor.
             * @memberof geelevel.protobuf
             * @interface ISetShowRemoteCursor
             * @property {boolean|null} [value] SetShowRemoteCursor value
             * @property {number|null} [index] SetShowRemoteCursor index
             */

            /**
             * Constructs a new SetShowRemoteCursor.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetShowRemoteCursor.
             * @implements ISetShowRemoteCursor
             * @constructor
             * @param {geelevel.protobuf.ISetShowRemoteCursor=} [properties] Properties to set
             */
            function SetShowRemoteCursor(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetShowRemoteCursor value.
             * @member {boolean} value
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @instance
             */
            SetShowRemoteCursor.prototype.value = false;

            /**
             * SetShowRemoteCursor index.
             * @member {number} index
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @instance
             */
            SetShowRemoteCursor.prototype.index = 0;

            /**
             * Creates a new SetShowRemoteCursor instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @static
             * @param {geelevel.protobuf.ISetShowRemoteCursor=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetShowRemoteCursor} SetShowRemoteCursor instance
             */
            SetShowRemoteCursor.create = function create(properties) {
                return new SetShowRemoteCursor(properties);
            };

            /**
             * Encodes the specified SetShowRemoteCursor message. Does not implicitly {@link geelevel.protobuf.SetShowRemoteCursor.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @static
             * @param {geelevel.protobuf.ISetShowRemoteCursor} message SetShowRemoteCursor message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetShowRemoteCursor.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.value);
                if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.index);
                return writer;
            };

            /**
             * Encodes the specified SetShowRemoteCursor message, length delimited. Does not implicitly {@link geelevel.protobuf.SetShowRemoteCursor.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @static
             * @param {geelevel.protobuf.ISetShowRemoteCursor} message SetShowRemoteCursor message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetShowRemoteCursor.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetShowRemoteCursor message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetShowRemoteCursor} SetShowRemoteCursor
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetShowRemoteCursor.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetShowRemoteCursor();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.value = reader.bool();
                            break;
                        }
                    case 2: {
                            message.index = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetShowRemoteCursor message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetShowRemoteCursor} SetShowRemoteCursor
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetShowRemoteCursor.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetShowRemoteCursor message.
             * @function verify
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetShowRemoteCursor.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "boolean")
                        return "value: boolean expected";
                if (message.index != null && message.hasOwnProperty("index"))
                    if (!$util.isInteger(message.index))
                        return "index: integer expected";
                return null;
            };

            /**
             * Creates a SetShowRemoteCursor message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetShowRemoteCursor} SetShowRemoteCursor
             */
            SetShowRemoteCursor.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetShowRemoteCursor)
                    return object;
                var message = new $root.geelevel.protobuf.SetShowRemoteCursor();
                if (object.value != null)
                    message.value = Boolean(object.value);
                if (object.index != null)
                    message.index = object.index >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SetShowRemoteCursor message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @static
             * @param {geelevel.protobuf.SetShowRemoteCursor} message SetShowRemoteCursor
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetShowRemoteCursor.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.value = false;
                    object.index = 0;
                }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                if (message.index != null && message.hasOwnProperty("index"))
                    object.index = message.index;
                return object;
            };

            /**
             * Converts this SetShowRemoteCursor to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetShowRemoteCursor.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetShowRemoteCursor
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetShowRemoteCursor
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetShowRemoteCursor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetShowRemoteCursor";
            };

            return SetShowRemoteCursor;
        })();

        protobuf.SetClipboardData = (function() {

            /**
             * Properties of a SetClipboardData.
             * @memberof geelevel.protobuf
             * @interface ISetClipboardData
             * @property {string|null} [type] SetClipboardData type
             * @property {Uint8Array|null} [data] SetClipboardData data
             */

            /**
             * Constructs a new SetClipboardData.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetClipboardData.
             * @implements ISetClipboardData
             * @constructor
             * @param {geelevel.protobuf.ISetClipboardData=} [properties] Properties to set
             */
            function SetClipboardData(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetClipboardData type.
             * @member {string} type
             * @memberof geelevel.protobuf.SetClipboardData
             * @instance
             */
            SetClipboardData.prototype.type = "";

            /**
             * SetClipboardData data.
             * @member {Uint8Array} data
             * @memberof geelevel.protobuf.SetClipboardData
             * @instance
             */
            SetClipboardData.prototype.data = $util.newBuffer([]);

            /**
             * Creates a new SetClipboardData instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetClipboardData
             * @static
             * @param {geelevel.protobuf.ISetClipboardData=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetClipboardData} SetClipboardData instance
             */
            SetClipboardData.create = function create(properties) {
                return new SetClipboardData(properties);
            };

            /**
             * Encodes the specified SetClipboardData message. Does not implicitly {@link geelevel.protobuf.SetClipboardData.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetClipboardData
             * @static
             * @param {geelevel.protobuf.ISetClipboardData} message SetClipboardData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetClipboardData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
                return writer;
            };

            /**
             * Encodes the specified SetClipboardData message, length delimited. Does not implicitly {@link geelevel.protobuf.SetClipboardData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetClipboardData
             * @static
             * @param {geelevel.protobuf.ISetClipboardData} message SetClipboardData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetClipboardData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetClipboardData message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetClipboardData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetClipboardData} SetClipboardData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetClipboardData.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetClipboardData();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.type = reader.string();
                            break;
                        }
                    case 2: {
                            message.data = reader.bytes();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetClipboardData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetClipboardData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetClipboardData} SetClipboardData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetClipboardData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetClipboardData message.
             * @function verify
             * @memberof geelevel.protobuf.SetClipboardData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetClipboardData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                        return "data: buffer expected";
                return null;
            };

            /**
             * Creates a SetClipboardData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetClipboardData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetClipboardData} SetClipboardData
             */
            SetClipboardData.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetClipboardData)
                    return object;
                var message = new $root.geelevel.protobuf.SetClipboardData();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length >= 0)
                        message.data = object.data;
                return message;
            };

            /**
             * Creates a plain object from a SetClipboardData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetClipboardData
             * @static
             * @param {geelevel.protobuf.SetClipboardData} message SetClipboardData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetClipboardData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type = "";
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                return object;
            };

            /**
             * Converts this SetClipboardData to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetClipboardData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetClipboardData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetClipboardData
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetClipboardData
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetClipboardData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetClipboardData";
            };

            return SetClipboardData;
        })();

        protobuf.MouseData = (function() {

            /**
             * Properties of a MouseData.
             * @memberof geelevel.protobuf
             * @interface IMouseData
             * @property {number|null} [event] MouseData event
             * @property {number|null} [x] MouseData x
             * @property {number|null} [y] MouseData y
             * @property {number|null} [buttonState] MouseData buttonState
             * @property {number|null} [keyboardState] MouseData keyboardState
             */

            /**
             * Constructs a new MouseData.
             * @memberof geelevel.protobuf
             * @classdesc Represents a MouseData.
             * @implements IMouseData
             * @constructor
             * @param {geelevel.protobuf.IMouseData=} [properties] Properties to set
             */
            function MouseData(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MouseData event.
             * @member {number} event
             * @memberof geelevel.protobuf.MouseData
             * @instance
             */
            MouseData.prototype.event = 0;

            /**
             * MouseData x.
             * @member {number} x
             * @memberof geelevel.protobuf.MouseData
             * @instance
             */
            MouseData.prototype.x = 0;

            /**
             * MouseData y.
             * @member {number} y
             * @memberof geelevel.protobuf.MouseData
             * @instance
             */
            MouseData.prototype.y = 0;

            /**
             * MouseData buttonState.
             * @member {number} buttonState
             * @memberof geelevel.protobuf.MouseData
             * @instance
             */
            MouseData.prototype.buttonState = 0;

            /**
             * MouseData keyboardState.
             * @member {number} keyboardState
             * @memberof geelevel.protobuf.MouseData
             * @instance
             */
            MouseData.prototype.keyboardState = 0;

            /**
             * Creates a new MouseData instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.MouseData
             * @static
             * @param {geelevel.protobuf.IMouseData=} [properties] Properties to set
             * @returns {geelevel.protobuf.MouseData} MouseData instance
             */
            MouseData.create = function create(properties) {
                return new MouseData(properties);
            };

            /**
             * Encodes the specified MouseData message. Does not implicitly {@link geelevel.protobuf.MouseData.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.MouseData
             * @static
             * @param {geelevel.protobuf.IMouseData} message MouseData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MouseData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.event != null && Object.hasOwnProperty.call(message, "event"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.event);
                if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                    writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.x);
                if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                    writer.uint32(/* id 3, wireType 0 =*/24).sint32(message.y);
                if (message.buttonState != null && Object.hasOwnProperty.call(message, "buttonState"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.buttonState);
                if (message.keyboardState != null && Object.hasOwnProperty.call(message, "keyboardState"))
                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.keyboardState);
                return writer;
            };

            /**
             * Encodes the specified MouseData message, length delimited. Does not implicitly {@link geelevel.protobuf.MouseData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.MouseData
             * @static
             * @param {geelevel.protobuf.IMouseData} message MouseData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MouseData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MouseData message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.MouseData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.MouseData} MouseData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MouseData.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.MouseData();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.event = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.x = reader.sint32();
                            break;
                        }
                    case 3: {
                            message.y = reader.sint32();
                            break;
                        }
                    case 4: {
                            message.buttonState = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.keyboardState = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MouseData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.MouseData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.MouseData} MouseData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MouseData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MouseData message.
             * @function verify
             * @memberof geelevel.protobuf.MouseData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MouseData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.event != null && message.hasOwnProperty("event"))
                    if (!$util.isInteger(message.event))
                        return "event: integer expected";
                if (message.x != null && message.hasOwnProperty("x"))
                    if (!$util.isInteger(message.x))
                        return "x: integer expected";
                if (message.y != null && message.hasOwnProperty("y"))
                    if (!$util.isInteger(message.y))
                        return "y: integer expected";
                if (message.buttonState != null && message.hasOwnProperty("buttonState"))
                    if (!$util.isInteger(message.buttonState))
                        return "buttonState: integer expected";
                if (message.keyboardState != null && message.hasOwnProperty("keyboardState"))
                    if (!$util.isInteger(message.keyboardState))
                        return "keyboardState: integer expected";
                return null;
            };

            /**
             * Creates a MouseData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.MouseData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.MouseData} MouseData
             */
            MouseData.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.MouseData)
                    return object;
                var message = new $root.geelevel.protobuf.MouseData();
                if (object.event != null)
                    message.event = object.event >>> 0;
                if (object.x != null)
                    message.x = object.x | 0;
                if (object.y != null)
                    message.y = object.y | 0;
                if (object.buttonState != null)
                    message.buttonState = object.buttonState >>> 0;
                if (object.keyboardState != null)
                    message.keyboardState = object.keyboardState >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a MouseData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.MouseData
             * @static
             * @param {geelevel.protobuf.MouseData} message MouseData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MouseData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.event = 0;
                    object.x = 0;
                    object.y = 0;
                    object.buttonState = 0;
                    object.keyboardState = 0;
                }
                if (message.event != null && message.hasOwnProperty("event"))
                    object.event = message.event;
                if (message.x != null && message.hasOwnProperty("x"))
                    object.x = message.x;
                if (message.y != null && message.hasOwnProperty("y"))
                    object.y = message.y;
                if (message.buttonState != null && message.hasOwnProperty("buttonState"))
                    object.buttonState = message.buttonState;
                if (message.keyboardState != null && message.hasOwnProperty("keyboardState"))
                    object.keyboardState = message.keyboardState;
                return object;
            };

            /**
             * Converts this MouseData to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.MouseData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MouseData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MouseData
             * @function getTypeUrl
             * @memberof geelevel.protobuf.MouseData
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MouseData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.MouseData";
            };

            return MouseData;
        })();

        protobuf.KeyboardData = (function() {

            /**
             * Properties of a KeyboardData.
             * @memberof geelevel.protobuf
             * @interface IKeyboardData
             * @property {number|null} [event] KeyboardData event
             * @property {number|null} [keyCode] KeyboardData keyCode
             * @property {number|null} [keyboardState] KeyboardData keyboardState
             */

            /**
             * Constructs a new KeyboardData.
             * @memberof geelevel.protobuf
             * @classdesc Represents a KeyboardData.
             * @implements IKeyboardData
             * @constructor
             * @param {geelevel.protobuf.IKeyboardData=} [properties] Properties to set
             */
            function KeyboardData(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * KeyboardData event.
             * @member {number} event
             * @memberof geelevel.protobuf.KeyboardData
             * @instance
             */
            KeyboardData.prototype.event = 0;

            /**
             * KeyboardData keyCode.
             * @member {number} keyCode
             * @memberof geelevel.protobuf.KeyboardData
             * @instance
             */
            KeyboardData.prototype.keyCode = 0;

            /**
             * KeyboardData keyboardState.
             * @member {number} keyboardState
             * @memberof geelevel.protobuf.KeyboardData
             * @instance
             */
            KeyboardData.prototype.keyboardState = 0;

            /**
             * Creates a new KeyboardData instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.KeyboardData
             * @static
             * @param {geelevel.protobuf.IKeyboardData=} [properties] Properties to set
             * @returns {geelevel.protobuf.KeyboardData} KeyboardData instance
             */
            KeyboardData.create = function create(properties) {
                return new KeyboardData(properties);
            };

            /**
             * Encodes the specified KeyboardData message. Does not implicitly {@link geelevel.protobuf.KeyboardData.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.KeyboardData
             * @static
             * @param {geelevel.protobuf.IKeyboardData} message KeyboardData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            KeyboardData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.event != null && Object.hasOwnProperty.call(message, "event"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.event);
                if (message.keyCode != null && Object.hasOwnProperty.call(message, "keyCode"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.keyCode);
                if (message.keyboardState != null && Object.hasOwnProperty.call(message, "keyboardState"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.keyboardState);
                return writer;
            };

            /**
             * Encodes the specified KeyboardData message, length delimited. Does not implicitly {@link geelevel.protobuf.KeyboardData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.KeyboardData
             * @static
             * @param {geelevel.protobuf.IKeyboardData} message KeyboardData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            KeyboardData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a KeyboardData message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.KeyboardData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.KeyboardData} KeyboardData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            KeyboardData.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.KeyboardData();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.event = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.keyCode = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.keyboardState = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a KeyboardData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.KeyboardData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.KeyboardData} KeyboardData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            KeyboardData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a KeyboardData message.
             * @function verify
             * @memberof geelevel.protobuf.KeyboardData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            KeyboardData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.event != null && message.hasOwnProperty("event"))
                    if (!$util.isInteger(message.event))
                        return "event: integer expected";
                if (message.keyCode != null && message.hasOwnProperty("keyCode"))
                    if (!$util.isInteger(message.keyCode))
                        return "keyCode: integer expected";
                if (message.keyboardState != null && message.hasOwnProperty("keyboardState"))
                    if (!$util.isInteger(message.keyboardState))
                        return "keyboardState: integer expected";
                return null;
            };

            /**
             * Creates a KeyboardData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.KeyboardData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.KeyboardData} KeyboardData
             */
            KeyboardData.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.KeyboardData)
                    return object;
                var message = new $root.geelevel.protobuf.KeyboardData();
                if (object.event != null)
                    message.event = object.event >>> 0;
                if (object.keyCode != null)
                    message.keyCode = object.keyCode >>> 0;
                if (object.keyboardState != null)
                    message.keyboardState = object.keyboardState >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a KeyboardData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.KeyboardData
             * @static
             * @param {geelevel.protobuf.KeyboardData} message KeyboardData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            KeyboardData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.event = 0;
                    object.keyCode = 0;
                    object.keyboardState = 0;
                }
                if (message.event != null && message.hasOwnProperty("event"))
                    object.event = message.event;
                if (message.keyCode != null && message.hasOwnProperty("keyCode"))
                    object.keyCode = message.keyCode;
                if (message.keyboardState != null && message.hasOwnProperty("keyboardState"))
                    object.keyboardState = message.keyboardState;
                return object;
            };

            /**
             * Converts this KeyboardData to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.KeyboardData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            KeyboardData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for KeyboardData
             * @function getTypeUrl
             * @memberof geelevel.protobuf.KeyboardData
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            KeyboardData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.KeyboardData";
            };

            return KeyboardData;
        })();

        protobuf.SetCursorData = (function() {

            /**
             * Properties of a SetCursorData.
             * @memberof geelevel.protobuf
             * @interface ISetCursorData
             * @property {number|null} [id] SetCursorData id
             * @property {number|null} [x] SetCursorData x
             * @property {number|null} [y] SetCursorData y
             * @property {number|null} [width] SetCursorData width
             * @property {number|null} [height] SetCursorData height
             * @property {Uint8Array|null} [data] SetCursorData data
             */

            /**
             * Constructs a new SetCursorData.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetCursorData.
             * @implements ISetCursorData
             * @constructor
             * @param {geelevel.protobuf.ISetCursorData=} [properties] Properties to set
             */
            function SetCursorData(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetCursorData id.
             * @member {number} id
             * @memberof geelevel.protobuf.SetCursorData
             * @instance
             */
            SetCursorData.prototype.id = 0;

            /**
             * SetCursorData x.
             * @member {number} x
             * @memberof geelevel.protobuf.SetCursorData
             * @instance
             */
            SetCursorData.prototype.x = 0;

            /**
             * SetCursorData y.
             * @member {number} y
             * @memberof geelevel.protobuf.SetCursorData
             * @instance
             */
            SetCursorData.prototype.y = 0;

            /**
             * SetCursorData width.
             * @member {number} width
             * @memberof geelevel.protobuf.SetCursorData
             * @instance
             */
            SetCursorData.prototype.width = 0;

            /**
             * SetCursorData height.
             * @member {number} height
             * @memberof geelevel.protobuf.SetCursorData
             * @instance
             */
            SetCursorData.prototype.height = 0;

            /**
             * SetCursorData data.
             * @member {Uint8Array} data
             * @memberof geelevel.protobuf.SetCursorData
             * @instance
             */
            SetCursorData.prototype.data = $util.newBuffer([]);

            /**
             * Creates a new SetCursorData instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetCursorData
             * @static
             * @param {geelevel.protobuf.ISetCursorData=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetCursorData} SetCursorData instance
             */
            SetCursorData.create = function create(properties) {
                return new SetCursorData(properties);
            };

            /**
             * Encodes the specified SetCursorData message. Does not implicitly {@link geelevel.protobuf.SetCursorData.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetCursorData
             * @static
             * @param {geelevel.protobuf.ISetCursorData} message SetCursorData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetCursorData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
                if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                    writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.x);
                if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                    writer.uint32(/* id 3, wireType 0 =*/24).sint32(message.y);
                if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.width);
                if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.height);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.data);
                return writer;
            };

            /**
             * Encodes the specified SetCursorData message, length delimited. Does not implicitly {@link geelevel.protobuf.SetCursorData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetCursorData
             * @static
             * @param {geelevel.protobuf.ISetCursorData} message SetCursorData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetCursorData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetCursorData message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetCursorData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetCursorData} SetCursorData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetCursorData.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetCursorData();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.x = reader.sint32();
                            break;
                        }
                    case 3: {
                            message.y = reader.sint32();
                            break;
                        }
                    case 4: {
                            message.width = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.height = reader.uint32();
                            break;
                        }
                    case 6: {
                            message.data = reader.bytes();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetCursorData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetCursorData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetCursorData} SetCursorData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetCursorData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetCursorData message.
             * @function verify
             * @memberof geelevel.protobuf.SetCursorData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetCursorData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id))
                        return "id: integer expected";
                if (message.x != null && message.hasOwnProperty("x"))
                    if (!$util.isInteger(message.x))
                        return "x: integer expected";
                if (message.y != null && message.hasOwnProperty("y"))
                    if (!$util.isInteger(message.y))
                        return "y: integer expected";
                if (message.width != null && message.hasOwnProperty("width"))
                    if (!$util.isInteger(message.width))
                        return "width: integer expected";
                if (message.height != null && message.hasOwnProperty("height"))
                    if (!$util.isInteger(message.height))
                        return "height: integer expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                        return "data: buffer expected";
                return null;
            };

            /**
             * Creates a SetCursorData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetCursorData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetCursorData} SetCursorData
             */
            SetCursorData.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetCursorData)
                    return object;
                var message = new $root.geelevel.protobuf.SetCursorData();
                if (object.id != null)
                    message.id = object.id >>> 0;
                if (object.x != null)
                    message.x = object.x | 0;
                if (object.y != null)
                    message.y = object.y | 0;
                if (object.width != null)
                    message.width = object.width >>> 0;
                if (object.height != null)
                    message.height = object.height >>> 0;
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length >= 0)
                        message.data = object.data;
                return message;
            };

            /**
             * Creates a plain object from a SetCursorData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetCursorData
             * @static
             * @param {geelevel.protobuf.SetCursorData} message SetCursorData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetCursorData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = 0;
                    object.x = 0;
                    object.y = 0;
                    object.width = 0;
                    object.height = 0;
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.x != null && message.hasOwnProperty("x"))
                    object.x = message.x;
                if (message.y != null && message.hasOwnProperty("y"))
                    object.y = message.y;
                if (message.width != null && message.hasOwnProperty("width"))
                    object.width = message.width;
                if (message.height != null && message.hasOwnProperty("height"))
                    object.height = message.height;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                return object;
            };

            /**
             * Converts this SetCursorData to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetCursorData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetCursorData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetCursorData
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetCursorData
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetCursorData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetCursorData";
            };

            return SetCursorData;
        })();

        protobuf.MountHdd = (function() {

            /**
             * Properties of a MountHdd.
             * @memberof geelevel.protobuf
             * @interface IMountHdd
             * @property {string|null} [path] MountHdd path
             * @property {string|null} [label] MountHdd label
             * @property {number|null} [authorify] MountHdd authorify
             */

            /**
             * Constructs a new MountHdd.
             * @memberof geelevel.protobuf
             * @classdesc Represents a MountHdd.
             * @implements IMountHdd
             * @constructor
             * @param {geelevel.protobuf.IMountHdd=} [properties] Properties to set
             */
            function MountHdd(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MountHdd path.
             * @member {string} path
             * @memberof geelevel.protobuf.MountHdd
             * @instance
             */
            MountHdd.prototype.path = "";

            /**
             * MountHdd label.
             * @member {string} label
             * @memberof geelevel.protobuf.MountHdd
             * @instance
             */
            MountHdd.prototype.label = "";

            /**
             * MountHdd authorify.
             * @member {number} authorify
             * @memberof geelevel.protobuf.MountHdd
             * @instance
             */
            MountHdd.prototype.authorify = 0;

            /**
             * Creates a new MountHdd instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.MountHdd
             * @static
             * @param {geelevel.protobuf.IMountHdd=} [properties] Properties to set
             * @returns {geelevel.protobuf.MountHdd} MountHdd instance
             */
            MountHdd.create = function create(properties) {
                return new MountHdd(properties);
            };

            /**
             * Encodes the specified MountHdd message. Does not implicitly {@link geelevel.protobuf.MountHdd.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.MountHdd
             * @static
             * @param {geelevel.protobuf.IMountHdd} message MountHdd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MountHdd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
                if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
                if (message.authorify != null && Object.hasOwnProperty.call(message, "authorify"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.authorify);
                return writer;
            };

            /**
             * Encodes the specified MountHdd message, length delimited. Does not implicitly {@link geelevel.protobuf.MountHdd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.MountHdd
             * @static
             * @param {geelevel.protobuf.IMountHdd} message MountHdd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MountHdd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MountHdd message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.MountHdd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.MountHdd} MountHdd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MountHdd.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.MountHdd();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.path = reader.string();
                            break;
                        }
                    case 2: {
                            message.label = reader.string();
                            break;
                        }
                    case 3: {
                            message.authorify = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MountHdd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.MountHdd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.MountHdd} MountHdd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MountHdd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MountHdd message.
             * @function verify
             * @memberof geelevel.protobuf.MountHdd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MountHdd.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.path != null && message.hasOwnProperty("path"))
                    if (!$util.isString(message.path))
                        return "path: string expected";
                if (message.label != null && message.hasOwnProperty("label"))
                    if (!$util.isString(message.label))
                        return "label: string expected";
                if (message.authorify != null && message.hasOwnProperty("authorify"))
                    if (!$util.isInteger(message.authorify))
                        return "authorify: integer expected";
                return null;
            };

            /**
             * Creates a MountHdd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.MountHdd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.MountHdd} MountHdd
             */
            MountHdd.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.MountHdd)
                    return object;
                var message = new $root.geelevel.protobuf.MountHdd();
                if (object.path != null)
                    message.path = String(object.path);
                if (object.label != null)
                    message.label = String(object.label);
                if (object.authorify != null)
                    message.authorify = object.authorify >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a MountHdd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.MountHdd
             * @static
             * @param {geelevel.protobuf.MountHdd} message MountHdd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MountHdd.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.path = "";
                    object.label = "";
                    object.authorify = 0;
                }
                if (message.path != null && message.hasOwnProperty("path"))
                    object.path = message.path;
                if (message.label != null && message.hasOwnProperty("label"))
                    object.label = message.label;
                if (message.authorify != null && message.hasOwnProperty("authorify"))
                    object.authorify = message.authorify;
                return object;
            };

            /**
             * Converts this MountHdd to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.MountHdd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MountHdd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MountHdd
             * @function getTypeUrl
             * @memberof geelevel.protobuf.MountHdd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MountHdd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.MountHdd";
            };

            return MountHdd;
        })();

        protobuf.FileTransferBegin = (function() {

            /**
             * Properties of a FileTransferBegin.
             * @memberof geelevel.protobuf
             * @interface IFileTransferBegin
             * @property {number|Long|null} [id] FileTransferBegin id
             * @property {Uint8Array|null} [name] FileTransferBegin name
             * @property {number|Long|null} [size] FileTransferBegin size
             */

            /**
             * Constructs a new FileTransferBegin.
             * @memberof geelevel.protobuf
             * @classdesc Represents a FileTransferBegin.
             * @implements IFileTransferBegin
             * @constructor
             * @param {geelevel.protobuf.IFileTransferBegin=} [properties] Properties to set
             */
            function FileTransferBegin(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileTransferBegin id.
             * @member {number|Long} id
             * @memberof geelevel.protobuf.FileTransferBegin
             * @instance
             */
            FileTransferBegin.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * FileTransferBegin name.
             * @member {Uint8Array} name
             * @memberof geelevel.protobuf.FileTransferBegin
             * @instance
             */
            FileTransferBegin.prototype.name = $util.newBuffer([]);

            /**
             * FileTransferBegin size.
             * @member {number|Long} size
             * @memberof geelevel.protobuf.FileTransferBegin
             * @instance
             */
            FileTransferBegin.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new FileTransferBegin instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.FileTransferBegin
             * @static
             * @param {geelevel.protobuf.IFileTransferBegin=} [properties] Properties to set
             * @returns {geelevel.protobuf.FileTransferBegin} FileTransferBegin instance
             */
            FileTransferBegin.create = function create(properties) {
                return new FileTransferBegin(properties);
            };

            /**
             * Encodes the specified FileTransferBegin message. Does not implicitly {@link geelevel.protobuf.FileTransferBegin.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.FileTransferBegin
             * @static
             * @param {geelevel.protobuf.IFileTransferBegin} message FileTransferBegin message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferBegin.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.id);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.name);
                if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.size);
                return writer;
            };

            /**
             * Encodes the specified FileTransferBegin message, length delimited. Does not implicitly {@link geelevel.protobuf.FileTransferBegin.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.FileTransferBegin
             * @static
             * @param {geelevel.protobuf.IFileTransferBegin} message FileTransferBegin message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferBegin.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileTransferBegin message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.FileTransferBegin
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.FileTransferBegin} FileTransferBegin
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferBegin.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.FileTransferBegin();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.name = reader.bytes();
                            break;
                        }
                    case 3: {
                            message.size = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileTransferBegin message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.FileTransferBegin
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.FileTransferBegin} FileTransferBegin
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferBegin.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileTransferBegin message.
             * @function verify
             * @memberof geelevel.protobuf.FileTransferBegin
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileTransferBegin.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                        return "id: integer|Long expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!(message.name && typeof message.name.length === "number" || $util.isString(message.name)))
                        return "name: buffer expected";
                if (message.size != null && message.hasOwnProperty("size"))
                    if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                        return "size: integer|Long expected";
                return null;
            };

            /**
             * Creates a FileTransferBegin message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.FileTransferBegin
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.FileTransferBegin} FileTransferBegin
             */
            FileTransferBegin.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.FileTransferBegin)
                    return object;
                var message = new $root.geelevel.protobuf.FileTransferBegin();
                if (object.id != null)
                    if ($util.Long)
                        (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                    else if (typeof object.id === "string")
                        message.id = parseInt(object.id, 10);
                    else if (typeof object.id === "number")
                        message.id = object.id;
                    else if (typeof object.id === "object")
                        message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
                if (object.name != null)
                    if (typeof object.name === "string")
                        $util.base64.decode(object.name, message.name = $util.newBuffer($util.base64.length(object.name)), 0);
                    else if (object.name.length >= 0)
                        message.name = object.name;
                if (object.size != null)
                    if ($util.Long)
                        (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                    else if (typeof object.size === "string")
                        message.size = parseInt(object.size, 10);
                    else if (typeof object.size === "number")
                        message.size = object.size;
                    else if (typeof object.size === "object")
                        message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a FileTransferBegin message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.FileTransferBegin
             * @static
             * @param {geelevel.protobuf.FileTransferBegin} message FileTransferBegin
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileTransferBegin.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.id = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.name = "";
                    else {
                        object.name = [];
                        if (options.bytes !== Array)
                            object.name = $util.newBuffer(object.name);
                    }
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.size = options.longs === String ? "0" : 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    if (typeof message.id === "number")
                        object.id = options.longs === String ? String(message.id) : message.id;
                    else
                        object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = options.bytes === String ? $util.base64.encode(message.name, 0, message.name.length) : options.bytes === Array ? Array.prototype.slice.call(message.name) : message.name;
                if (message.size != null && message.hasOwnProperty("size"))
                    if (typeof message.size === "number")
                        object.size = options.longs === String ? String(message.size) : message.size;
                    else
                        object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
                return object;
            };

            /**
             * Converts this FileTransferBegin to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.FileTransferBegin
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileTransferBegin.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FileTransferBegin
             * @function getTypeUrl
             * @memberof geelevel.protobuf.FileTransferBegin
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FileTransferBegin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.FileTransferBegin";
            };

            return FileTransferBegin;
        })();

        protobuf.FileTransferBeginAck = (function() {

            /**
             * Properties of a FileTransferBeginAck.
             * @memberof geelevel.protobuf
             * @interface IFileTransferBeginAck
             * @property {number|null} [result] FileTransferBeginAck result
             * @property {number|Long|null} [id] FileTransferBeginAck id
             */

            /**
             * Constructs a new FileTransferBeginAck.
             * @memberof geelevel.protobuf
             * @classdesc Represents a FileTransferBeginAck.
             * @implements IFileTransferBeginAck
             * @constructor
             * @param {geelevel.protobuf.IFileTransferBeginAck=} [properties] Properties to set
             */
            function FileTransferBeginAck(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileTransferBeginAck result.
             * @member {number} result
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @instance
             */
            FileTransferBeginAck.prototype.result = 0;

            /**
             * FileTransferBeginAck id.
             * @member {number|Long} id
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @instance
             */
            FileTransferBeginAck.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new FileTransferBeginAck instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @static
             * @param {geelevel.protobuf.IFileTransferBeginAck=} [properties] Properties to set
             * @returns {geelevel.protobuf.FileTransferBeginAck} FileTransferBeginAck instance
             */
            FileTransferBeginAck.create = function create(properties) {
                return new FileTransferBeginAck(properties);
            };

            /**
             * Encodes the specified FileTransferBeginAck message. Does not implicitly {@link geelevel.protobuf.FileTransferBeginAck.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @static
             * @param {geelevel.protobuf.IFileTransferBeginAck} message FileTransferBeginAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferBeginAck.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                    writer.uint32(/* id 1, wireType 0 =*/8).sint32(message.result);
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.id);
                return writer;
            };

            /**
             * Encodes the specified FileTransferBeginAck message, length delimited. Does not implicitly {@link geelevel.protobuf.FileTransferBeginAck.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @static
             * @param {geelevel.protobuf.IFileTransferBeginAck} message FileTransferBeginAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferBeginAck.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileTransferBeginAck message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.FileTransferBeginAck} FileTransferBeginAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferBeginAck.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.FileTransferBeginAck();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.result = reader.sint32();
                            break;
                        }
                    case 2: {
                            message.id = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileTransferBeginAck message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.FileTransferBeginAck} FileTransferBeginAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferBeginAck.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileTransferBeginAck message.
             * @function verify
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileTransferBeginAck.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.result != null && message.hasOwnProperty("result"))
                    if (!$util.isInteger(message.result))
                        return "result: integer expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                        return "id: integer|Long expected";
                return null;
            };

            /**
             * Creates a FileTransferBeginAck message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.FileTransferBeginAck} FileTransferBeginAck
             */
            FileTransferBeginAck.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.FileTransferBeginAck)
                    return object;
                var message = new $root.geelevel.protobuf.FileTransferBeginAck();
                if (object.result != null)
                    message.result = object.result | 0;
                if (object.id != null)
                    if ($util.Long)
                        (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                    else if (typeof object.id === "string")
                        message.id = parseInt(object.id, 10);
                    else if (typeof object.id === "number")
                        message.id = object.id;
                    else if (typeof object.id === "object")
                        message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a FileTransferBeginAck message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @static
             * @param {geelevel.protobuf.FileTransferBeginAck} message FileTransferBeginAck
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileTransferBeginAck.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.result = 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.id = options.longs === String ? "0" : 0;
                }
                if (message.result != null && message.hasOwnProperty("result"))
                    object.result = message.result;
                if (message.id != null && message.hasOwnProperty("id"))
                    if (typeof message.id === "number")
                        object.id = options.longs === String ? String(message.id) : message.id;
                    else
                        object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                return object;
            };

            /**
             * Converts this FileTransferBeginAck to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileTransferBeginAck.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FileTransferBeginAck
             * @function getTypeUrl
             * @memberof geelevel.protobuf.FileTransferBeginAck
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FileTransferBeginAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.FileTransferBeginAck";
            };

            return FileTransferBeginAck;
        })();

        protobuf.FileTransferData = (function() {

            /**
             * Properties of a FileTransferData.
             * @memberof geelevel.protobuf
             * @interface IFileTransferData
             * @property {number|Long|null} [id] FileTransferData id
             * @property {string|null} [md5] FileTransferData md5
             * @property {Uint8Array|null} [data] FileTransferData data
             */

            /**
             * Constructs a new FileTransferData.
             * @memberof geelevel.protobuf
             * @classdesc Represents a FileTransferData.
             * @implements IFileTransferData
             * @constructor
             * @param {geelevel.protobuf.IFileTransferData=} [properties] Properties to set
             */
            function FileTransferData(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileTransferData id.
             * @member {number|Long} id
             * @memberof geelevel.protobuf.FileTransferData
             * @instance
             */
            FileTransferData.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * FileTransferData md5.
             * @member {string} md5
             * @memberof geelevel.protobuf.FileTransferData
             * @instance
             */
            FileTransferData.prototype.md5 = "";

            /**
             * FileTransferData data.
             * @member {Uint8Array} data
             * @memberof geelevel.protobuf.FileTransferData
             * @instance
             */
            FileTransferData.prototype.data = $util.newBuffer([]);

            /**
             * Creates a new FileTransferData instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.FileTransferData
             * @static
             * @param {geelevel.protobuf.IFileTransferData=} [properties] Properties to set
             * @returns {geelevel.protobuf.FileTransferData} FileTransferData instance
             */
            FileTransferData.create = function create(properties) {
                return new FileTransferData(properties);
            };

            /**
             * Encodes the specified FileTransferData message. Does not implicitly {@link geelevel.protobuf.FileTransferData.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.FileTransferData
             * @static
             * @param {geelevel.protobuf.IFileTransferData} message FileTransferData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.id);
                if (message.md5 != null && Object.hasOwnProperty.call(message, "md5"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.md5);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.data);
                return writer;
            };

            /**
             * Encodes the specified FileTransferData message, length delimited. Does not implicitly {@link geelevel.protobuf.FileTransferData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.FileTransferData
             * @static
             * @param {geelevel.protobuf.IFileTransferData} message FileTransferData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileTransferData message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.FileTransferData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.FileTransferData} FileTransferData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferData.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.FileTransferData();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.md5 = reader.string();
                            break;
                        }
                    case 3: {
                            message.data = reader.bytes();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileTransferData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.FileTransferData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.FileTransferData} FileTransferData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileTransferData message.
             * @function verify
             * @memberof geelevel.protobuf.FileTransferData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileTransferData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                        return "id: integer|Long expected";
                if (message.md5 != null && message.hasOwnProperty("md5"))
                    if (!$util.isString(message.md5))
                        return "md5: string expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                        return "data: buffer expected";
                return null;
            };

            /**
             * Creates a FileTransferData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.FileTransferData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.FileTransferData} FileTransferData
             */
            FileTransferData.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.FileTransferData)
                    return object;
                var message = new $root.geelevel.protobuf.FileTransferData();
                if (object.id != null)
                    if ($util.Long)
                        (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                    else if (typeof object.id === "string")
                        message.id = parseInt(object.id, 10);
                    else if (typeof object.id === "number")
                        message.id = object.id;
                    else if (typeof object.id === "object")
                        message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
                if (object.md5 != null)
                    message.md5 = String(object.md5);
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length >= 0)
                        message.data = object.data;
                return message;
            };

            /**
             * Creates a plain object from a FileTransferData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.FileTransferData
             * @static
             * @param {geelevel.protobuf.FileTransferData} message FileTransferData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileTransferData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.id = options.longs === String ? "0" : 0;
                    object.md5 = "";
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    if (typeof message.id === "number")
                        object.id = options.longs === String ? String(message.id) : message.id;
                    else
                        object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                if (message.md5 != null && message.hasOwnProperty("md5"))
                    object.md5 = message.md5;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                return object;
            };

            /**
             * Converts this FileTransferData to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.FileTransferData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileTransferData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FileTransferData
             * @function getTypeUrl
             * @memberof geelevel.protobuf.FileTransferData
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FileTransferData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.FileTransferData";
            };

            return FileTransferData;
        })();

        protobuf.FileTransferDataAck = (function() {

            /**
             * Properties of a FileTransferDataAck.
             * @memberof geelevel.protobuf
             * @interface IFileTransferDataAck
             * @property {number|null} [result] FileTransferDataAck result
             * @property {number|Long|null} [id] FileTransferDataAck id
             */

            /**
             * Constructs a new FileTransferDataAck.
             * @memberof geelevel.protobuf
             * @classdesc Represents a FileTransferDataAck.
             * @implements IFileTransferDataAck
             * @constructor
             * @param {geelevel.protobuf.IFileTransferDataAck=} [properties] Properties to set
             */
            function FileTransferDataAck(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileTransferDataAck result.
             * @member {number} result
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @instance
             */
            FileTransferDataAck.prototype.result = 0;

            /**
             * FileTransferDataAck id.
             * @member {number|Long} id
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @instance
             */
            FileTransferDataAck.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new FileTransferDataAck instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @static
             * @param {geelevel.protobuf.IFileTransferDataAck=} [properties] Properties to set
             * @returns {geelevel.protobuf.FileTransferDataAck} FileTransferDataAck instance
             */
            FileTransferDataAck.create = function create(properties) {
                return new FileTransferDataAck(properties);
            };

            /**
             * Encodes the specified FileTransferDataAck message. Does not implicitly {@link geelevel.protobuf.FileTransferDataAck.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @static
             * @param {geelevel.protobuf.IFileTransferDataAck} message FileTransferDataAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferDataAck.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                    writer.uint32(/* id 1, wireType 0 =*/8).sint32(message.result);
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.id);
                return writer;
            };

            /**
             * Encodes the specified FileTransferDataAck message, length delimited. Does not implicitly {@link geelevel.protobuf.FileTransferDataAck.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @static
             * @param {geelevel.protobuf.IFileTransferDataAck} message FileTransferDataAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferDataAck.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileTransferDataAck message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.FileTransferDataAck} FileTransferDataAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferDataAck.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.FileTransferDataAck();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.result = reader.sint32();
                            break;
                        }
                    case 2: {
                            message.id = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileTransferDataAck message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.FileTransferDataAck} FileTransferDataAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferDataAck.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileTransferDataAck message.
             * @function verify
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileTransferDataAck.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.result != null && message.hasOwnProperty("result"))
                    if (!$util.isInteger(message.result))
                        return "result: integer expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                        return "id: integer|Long expected";
                return null;
            };

            /**
             * Creates a FileTransferDataAck message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.FileTransferDataAck} FileTransferDataAck
             */
            FileTransferDataAck.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.FileTransferDataAck)
                    return object;
                var message = new $root.geelevel.protobuf.FileTransferDataAck();
                if (object.result != null)
                    message.result = object.result | 0;
                if (object.id != null)
                    if ($util.Long)
                        (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                    else if (typeof object.id === "string")
                        message.id = parseInt(object.id, 10);
                    else if (typeof object.id === "number")
                        message.id = object.id;
                    else if (typeof object.id === "object")
                        message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a FileTransferDataAck message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @static
             * @param {geelevel.protobuf.FileTransferDataAck} message FileTransferDataAck
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileTransferDataAck.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.result = 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.id = options.longs === String ? "0" : 0;
                }
                if (message.result != null && message.hasOwnProperty("result"))
                    object.result = message.result;
                if (message.id != null && message.hasOwnProperty("id"))
                    if (typeof message.id === "number")
                        object.id = options.longs === String ? String(message.id) : message.id;
                    else
                        object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                return object;
            };

            /**
             * Converts this FileTransferDataAck to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileTransferDataAck.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FileTransferDataAck
             * @function getTypeUrl
             * @memberof geelevel.protobuf.FileTransferDataAck
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FileTransferDataAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.FileTransferDataAck";
            };

            return FileTransferDataAck;
        })();

        protobuf.FileTransferEnd = (function() {

            /**
             * Properties of a FileTransferEnd.
             * @memberof geelevel.protobuf
             * @interface IFileTransferEnd
             * @property {number|Long|null} [id] FileTransferEnd id
             */

            /**
             * Constructs a new FileTransferEnd.
             * @memberof geelevel.protobuf
             * @classdesc Represents a FileTransferEnd.
             * @implements IFileTransferEnd
             * @constructor
             * @param {geelevel.protobuf.IFileTransferEnd=} [properties] Properties to set
             */
            function FileTransferEnd(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileTransferEnd id.
             * @member {number|Long} id
             * @memberof geelevel.protobuf.FileTransferEnd
             * @instance
             */
            FileTransferEnd.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new FileTransferEnd instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.FileTransferEnd
             * @static
             * @param {geelevel.protobuf.IFileTransferEnd=} [properties] Properties to set
             * @returns {geelevel.protobuf.FileTransferEnd} FileTransferEnd instance
             */
            FileTransferEnd.create = function create(properties) {
                return new FileTransferEnd(properties);
            };

            /**
             * Encodes the specified FileTransferEnd message. Does not implicitly {@link geelevel.protobuf.FileTransferEnd.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.FileTransferEnd
             * @static
             * @param {geelevel.protobuf.IFileTransferEnd} message FileTransferEnd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferEnd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.id);
                return writer;
            };

            /**
             * Encodes the specified FileTransferEnd message, length delimited. Does not implicitly {@link geelevel.protobuf.FileTransferEnd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.FileTransferEnd
             * @static
             * @param {geelevel.protobuf.IFileTransferEnd} message FileTransferEnd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferEnd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileTransferEnd message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.FileTransferEnd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.FileTransferEnd} FileTransferEnd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferEnd.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.FileTransferEnd();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileTransferEnd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.FileTransferEnd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.FileTransferEnd} FileTransferEnd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferEnd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileTransferEnd message.
             * @function verify
             * @memberof geelevel.protobuf.FileTransferEnd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileTransferEnd.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                        return "id: integer|Long expected";
                return null;
            };

            /**
             * Creates a FileTransferEnd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.FileTransferEnd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.FileTransferEnd} FileTransferEnd
             */
            FileTransferEnd.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.FileTransferEnd)
                    return object;
                var message = new $root.geelevel.protobuf.FileTransferEnd();
                if (object.id != null)
                    if ($util.Long)
                        (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                    else if (typeof object.id === "string")
                        message.id = parseInt(object.id, 10);
                    else if (typeof object.id === "number")
                        message.id = object.id;
                    else if (typeof object.id === "object")
                        message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a FileTransferEnd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.FileTransferEnd
             * @static
             * @param {geelevel.protobuf.FileTransferEnd} message FileTransferEnd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileTransferEnd.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.id = options.longs === String ? "0" : 0;
                if (message.id != null && message.hasOwnProperty("id"))
                    if (typeof message.id === "number")
                        object.id = options.longs === String ? String(message.id) : message.id;
                    else
                        object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                return object;
            };

            /**
             * Converts this FileTransferEnd to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.FileTransferEnd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileTransferEnd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FileTransferEnd
             * @function getTypeUrl
             * @memberof geelevel.protobuf.FileTransferEnd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FileTransferEnd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.FileTransferEnd";
            };

            return FileTransferEnd;
        })();

        protobuf.FileTransferEndAck = (function() {

            /**
             * Properties of a FileTransferEndAck.
             * @memberof geelevel.protobuf
             * @interface IFileTransferEndAck
             * @property {number|Long|null} [id] FileTransferEndAck id
             * @property {number|null} [result] FileTransferEndAck result
             */

            /**
             * Constructs a new FileTransferEndAck.
             * @memberof geelevel.protobuf
             * @classdesc Represents a FileTransferEndAck.
             * @implements IFileTransferEndAck
             * @constructor
             * @param {geelevel.protobuf.IFileTransferEndAck=} [properties] Properties to set
             */
            function FileTransferEndAck(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileTransferEndAck id.
             * @member {number|Long} id
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @instance
             */
            FileTransferEndAck.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * FileTransferEndAck result.
             * @member {number} result
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @instance
             */
            FileTransferEndAck.prototype.result = 0;

            /**
             * Creates a new FileTransferEndAck instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @static
             * @param {geelevel.protobuf.IFileTransferEndAck=} [properties] Properties to set
             * @returns {geelevel.protobuf.FileTransferEndAck} FileTransferEndAck instance
             */
            FileTransferEndAck.create = function create(properties) {
                return new FileTransferEndAck(properties);
            };

            /**
             * Encodes the specified FileTransferEndAck message. Does not implicitly {@link geelevel.protobuf.FileTransferEndAck.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @static
             * @param {geelevel.protobuf.IFileTransferEndAck} message FileTransferEndAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferEndAck.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.id);
                if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                    writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.result);
                return writer;
            };

            /**
             * Encodes the specified FileTransferEndAck message, length delimited. Does not implicitly {@link geelevel.protobuf.FileTransferEndAck.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @static
             * @param {geelevel.protobuf.IFileTransferEndAck} message FileTransferEndAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferEndAck.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileTransferEndAck message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.FileTransferEndAck} FileTransferEndAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferEndAck.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.FileTransferEndAck();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.result = reader.sint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileTransferEndAck message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.FileTransferEndAck} FileTransferEndAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferEndAck.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileTransferEndAck message.
             * @function verify
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileTransferEndAck.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                        return "id: integer|Long expected";
                if (message.result != null && message.hasOwnProperty("result"))
                    if (!$util.isInteger(message.result))
                        return "result: integer expected";
                return null;
            };

            /**
             * Creates a FileTransferEndAck message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.FileTransferEndAck} FileTransferEndAck
             */
            FileTransferEndAck.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.FileTransferEndAck)
                    return object;
                var message = new $root.geelevel.protobuf.FileTransferEndAck();
                if (object.id != null)
                    if ($util.Long)
                        (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                    else if (typeof object.id === "string")
                        message.id = parseInt(object.id, 10);
                    else if (typeof object.id === "number")
                        message.id = object.id;
                    else if (typeof object.id === "object")
                        message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
                if (object.result != null)
                    message.result = object.result | 0;
                return message;
            };

            /**
             * Creates a plain object from a FileTransferEndAck message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @static
             * @param {geelevel.protobuf.FileTransferEndAck} message FileTransferEndAck
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileTransferEndAck.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.id = options.longs === String ? "0" : 0;
                    object.result = 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    if (typeof message.id === "number")
                        object.id = options.longs === String ? String(message.id) : message.id;
                    else
                        object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                if (message.result != null && message.hasOwnProperty("result"))
                    object.result = message.result;
                return object;
            };

            /**
             * Converts this FileTransferEndAck to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileTransferEndAck.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FileTransferEndAck
             * @function getTypeUrl
             * @memberof geelevel.protobuf.FileTransferEndAck
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FileTransferEndAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.FileTransferEndAck";
            };

            return FileTransferEndAck;
        })();

        protobuf.FileTransferControl = (function() {

            /**
             * Properties of a FileTransferControl.
             * @memberof geelevel.protobuf
             * @interface IFileTransferControl
             * @property {number|Long|null} [id] FileTransferControl id
             * @property {number|null} [action] FileTransferControl action
             */

            /**
             * Constructs a new FileTransferControl.
             * @memberof geelevel.protobuf
             * @classdesc Represents a FileTransferControl.
             * @implements IFileTransferControl
             * @constructor
             * @param {geelevel.protobuf.IFileTransferControl=} [properties] Properties to set
             */
            function FileTransferControl(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileTransferControl id.
             * @member {number|Long} id
             * @memberof geelevel.protobuf.FileTransferControl
             * @instance
             */
            FileTransferControl.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * FileTransferControl action.
             * @member {number} action
             * @memberof geelevel.protobuf.FileTransferControl
             * @instance
             */
            FileTransferControl.prototype.action = 0;

            /**
             * Creates a new FileTransferControl instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.FileTransferControl
             * @static
             * @param {geelevel.protobuf.IFileTransferControl=} [properties] Properties to set
             * @returns {geelevel.protobuf.FileTransferControl} FileTransferControl instance
             */
            FileTransferControl.create = function create(properties) {
                return new FileTransferControl(properties);
            };

            /**
             * Encodes the specified FileTransferControl message. Does not implicitly {@link geelevel.protobuf.FileTransferControl.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.FileTransferControl
             * @static
             * @param {geelevel.protobuf.IFileTransferControl} message FileTransferControl message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferControl.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.id);
                if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.action);
                return writer;
            };

            /**
             * Encodes the specified FileTransferControl message, length delimited. Does not implicitly {@link geelevel.protobuf.FileTransferControl.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.FileTransferControl
             * @static
             * @param {geelevel.protobuf.IFileTransferControl} message FileTransferControl message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileTransferControl.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileTransferControl message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.FileTransferControl
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.FileTransferControl} FileTransferControl
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferControl.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.FileTransferControl();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.action = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileTransferControl message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.FileTransferControl
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.FileTransferControl} FileTransferControl
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileTransferControl.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileTransferControl message.
             * @function verify
             * @memberof geelevel.protobuf.FileTransferControl
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileTransferControl.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                        return "id: integer|Long expected";
                if (message.action != null && message.hasOwnProperty("action"))
                    if (!$util.isInteger(message.action))
                        return "action: integer expected";
                return null;
            };

            /**
             * Creates a FileTransferControl message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.FileTransferControl
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.FileTransferControl} FileTransferControl
             */
            FileTransferControl.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.FileTransferControl)
                    return object;
                var message = new $root.geelevel.protobuf.FileTransferControl();
                if (object.id != null)
                    if ($util.Long)
                        (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                    else if (typeof object.id === "string")
                        message.id = parseInt(object.id, 10);
                    else if (typeof object.id === "number")
                        message.id = object.id;
                    else if (typeof object.id === "object")
                        message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
                if (object.action != null)
                    message.action = object.action >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a FileTransferControl message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.FileTransferControl
             * @static
             * @param {geelevel.protobuf.FileTransferControl} message FileTransferControl
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileTransferControl.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.id = options.longs === String ? "0" : 0;
                    object.action = 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    if (typeof message.id === "number")
                        object.id = options.longs === String ? String(message.id) : message.id;
                    else
                        object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                if (message.action != null && message.hasOwnProperty("action"))
                    object.action = message.action;
                return object;
            };

            /**
             * Converts this FileTransferControl to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.FileTransferControl
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileTransferControl.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FileTransferControl
             * @function getTypeUrl
             * @memberof geelevel.protobuf.FileTransferControl
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FileTransferControl.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.FileTransferControl";
            };

            return FileTransferControl;
        })();

        protobuf.ListDirectories = (function() {

            /**
             * Properties of a ListDirectories.
             * @memberof geelevel.protobuf
             * @interface IListDirectories
             * @property {string|null} [path] ListDirectories path
             */

            /**
             * Constructs a new ListDirectories.
             * @memberof geelevel.protobuf
             * @classdesc Represents a ListDirectories.
             * @implements IListDirectories
             * @constructor
             * @param {geelevel.protobuf.IListDirectories=} [properties] Properties to set
             */
            function ListDirectories(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListDirectories path.
             * @member {string} path
             * @memberof geelevel.protobuf.ListDirectories
             * @instance
             */
            ListDirectories.prototype.path = "";

            /**
             * Creates a new ListDirectories instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.ListDirectories
             * @static
             * @param {geelevel.protobuf.IListDirectories=} [properties] Properties to set
             * @returns {geelevel.protobuf.ListDirectories} ListDirectories instance
             */
            ListDirectories.create = function create(properties) {
                return new ListDirectories(properties);
            };

            /**
             * Encodes the specified ListDirectories message. Does not implicitly {@link geelevel.protobuf.ListDirectories.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.ListDirectories
             * @static
             * @param {geelevel.protobuf.IListDirectories} message ListDirectories message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListDirectories.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
                return writer;
            };

            /**
             * Encodes the specified ListDirectories message, length delimited. Does not implicitly {@link geelevel.protobuf.ListDirectories.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.ListDirectories
             * @static
             * @param {geelevel.protobuf.IListDirectories} message ListDirectories message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListDirectories.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ListDirectories message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.ListDirectories
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.ListDirectories} ListDirectories
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListDirectories.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.ListDirectories();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.path = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ListDirectories message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.ListDirectories
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.ListDirectories} ListDirectories
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListDirectories.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ListDirectories message.
             * @function verify
             * @memberof geelevel.protobuf.ListDirectories
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ListDirectories.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.path != null && message.hasOwnProperty("path"))
                    if (!$util.isString(message.path))
                        return "path: string expected";
                return null;
            };

            /**
             * Creates a ListDirectories message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.ListDirectories
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.ListDirectories} ListDirectories
             */
            ListDirectories.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.ListDirectories)
                    return object;
                var message = new $root.geelevel.protobuf.ListDirectories();
                if (object.path != null)
                    message.path = String(object.path);
                return message;
            };

            /**
             * Creates a plain object from a ListDirectories message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.ListDirectories
             * @static
             * @param {geelevel.protobuf.ListDirectories} message ListDirectories
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListDirectories.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.path = "";
                if (message.path != null && message.hasOwnProperty("path"))
                    object.path = message.path;
                return object;
            };

            /**
             * Converts this ListDirectories to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.ListDirectories
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListDirectories.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ListDirectories
             * @function getTypeUrl
             * @memberof geelevel.protobuf.ListDirectories
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ListDirectories.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.ListDirectories";
            };

            return ListDirectories;
        })();

        protobuf.ListDirectoriesAck = (function() {

            /**
             * Properties of a ListDirectoriesAck.
             * @memberof geelevel.protobuf
             * @interface IListDirectoriesAck
             * @property {string|null} [path] ListDirectoriesAck path
             * @property {string|null} [data] ListDirectoriesAck data
             * @property {number|Long|null} [time] ListDirectoriesAck time
             */

            /**
             * Constructs a new ListDirectoriesAck.
             * @memberof geelevel.protobuf
             * @classdesc Represents a ListDirectoriesAck.
             * @implements IListDirectoriesAck
             * @constructor
             * @param {geelevel.protobuf.IListDirectoriesAck=} [properties] Properties to set
             */
            function ListDirectoriesAck(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListDirectoriesAck path.
             * @member {string} path
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @instance
             */
            ListDirectoriesAck.prototype.path = "";

            /**
             * ListDirectoriesAck data.
             * @member {string} data
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @instance
             */
            ListDirectoriesAck.prototype.data = "";

            /**
             * ListDirectoriesAck time.
             * @member {number|Long} time
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @instance
             */
            ListDirectoriesAck.prototype.time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new ListDirectoriesAck instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @static
             * @param {geelevel.protobuf.IListDirectoriesAck=} [properties] Properties to set
             * @returns {geelevel.protobuf.ListDirectoriesAck} ListDirectoriesAck instance
             */
            ListDirectoriesAck.create = function create(properties) {
                return new ListDirectoriesAck(properties);
            };

            /**
             * Encodes the specified ListDirectoriesAck message. Does not implicitly {@link geelevel.protobuf.ListDirectoriesAck.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @static
             * @param {geelevel.protobuf.IListDirectoriesAck} message ListDirectoriesAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListDirectoriesAck.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.data);
                if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.time);
                return writer;
            };

            /**
             * Encodes the specified ListDirectoriesAck message, length delimited. Does not implicitly {@link geelevel.protobuf.ListDirectoriesAck.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @static
             * @param {geelevel.protobuf.IListDirectoriesAck} message ListDirectoriesAck message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListDirectoriesAck.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ListDirectoriesAck message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.ListDirectoriesAck} ListDirectoriesAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListDirectoriesAck.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.ListDirectoriesAck();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.path = reader.string();
                            break;
                        }
                    case 2: {
                            message.data = reader.string();
                            break;
                        }
                    case 3: {
                            message.time = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ListDirectoriesAck message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.ListDirectoriesAck} ListDirectoriesAck
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListDirectoriesAck.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ListDirectoriesAck message.
             * @function verify
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ListDirectoriesAck.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.path != null && message.hasOwnProperty("path"))
                    if (!$util.isString(message.path))
                        return "path: string expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!$util.isString(message.data))
                        return "data: string expected";
                if (message.time != null && message.hasOwnProperty("time"))
                    if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                        return "time: integer|Long expected";
                return null;
            };

            /**
             * Creates a ListDirectoriesAck message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.ListDirectoriesAck} ListDirectoriesAck
             */
            ListDirectoriesAck.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.ListDirectoriesAck)
                    return object;
                var message = new $root.geelevel.protobuf.ListDirectoriesAck();
                if (object.path != null)
                    message.path = String(object.path);
                if (object.data != null)
                    message.data = String(object.data);
                if (object.time != null)
                    if ($util.Long)
                        (message.time = $util.Long.fromValue(object.time)).unsigned = true;
                    else if (typeof object.time === "string")
                        message.time = parseInt(object.time, 10);
                    else if (typeof object.time === "number")
                        message.time = object.time;
                    else if (typeof object.time === "object")
                        message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a ListDirectoriesAck message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @static
             * @param {geelevel.protobuf.ListDirectoriesAck} message ListDirectoriesAck
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListDirectoriesAck.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.path = "";
                    object.data = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.time = options.longs === String ? "0" : 0;
                }
                if (message.path != null && message.hasOwnProperty("path"))
                    object.path = message.path;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = message.data;
                if (message.time != null && message.hasOwnProperty("time"))
                    if (typeof message.time === "number")
                        object.time = options.longs === String ? String(message.time) : message.time;
                    else
                        object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber(true) : message.time;
                return object;
            };

            /**
             * Converts this ListDirectoriesAck to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListDirectoriesAck.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ListDirectoriesAck
             * @function getTypeUrl
             * @memberof geelevel.protobuf.ListDirectoriesAck
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ListDirectoriesAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.ListDirectoriesAck";
            };

            return ListDirectoriesAck;
        })();

        protobuf.BaseInfo = (function() {

            /**
             * Properties of a BaseInfo.
             * @memberof geelevel.protobuf
             * @interface IBaseInfo
             * @property {number|null} [id] BaseInfo id
             * @property {string|null} [ip] BaseInfo ip
             * @property {string|null} [networkType] BaseInfo networkType
             * @property {string|null} [protocol] BaseInfo protocol
             */

            /**
             * Constructs a new BaseInfo.
             * @memberof geelevel.protobuf
             * @classdesc Represents a BaseInfo.
             * @implements IBaseInfo
             * @constructor
             * @param {geelevel.protobuf.IBaseInfo=} [properties] Properties to set
             */
            function BaseInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BaseInfo id.
             * @member {number} id
             * @memberof geelevel.protobuf.BaseInfo
             * @instance
             */
            BaseInfo.prototype.id = 0;

            /**
             * BaseInfo ip.
             * @member {string} ip
             * @memberof geelevel.protobuf.BaseInfo
             * @instance
             */
            BaseInfo.prototype.ip = "";

            /**
             * BaseInfo networkType.
             * @member {string} networkType
             * @memberof geelevel.protobuf.BaseInfo
             * @instance
             */
            BaseInfo.prototype.networkType = "";

            /**
             * BaseInfo protocol.
             * @member {string} protocol
             * @memberof geelevel.protobuf.BaseInfo
             * @instance
             */
            BaseInfo.prototype.protocol = "";

            /**
             * Creates a new BaseInfo instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.BaseInfo
             * @static
             * @param {geelevel.protobuf.IBaseInfo=} [properties] Properties to set
             * @returns {geelevel.protobuf.BaseInfo} BaseInfo instance
             */
            BaseInfo.create = function create(properties) {
                return new BaseInfo(properties);
            };

            /**
             * Encodes the specified BaseInfo message. Does not implicitly {@link geelevel.protobuf.BaseInfo.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.BaseInfo
             * @static
             * @param {geelevel.protobuf.IBaseInfo} message BaseInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BaseInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
                if (message.ip != null && Object.hasOwnProperty.call(message, "ip"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.ip);
                if (message.networkType != null && Object.hasOwnProperty.call(message, "networkType"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.networkType);
                if (message.protocol != null && Object.hasOwnProperty.call(message, "protocol"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.protocol);
                return writer;
            };

            /**
             * Encodes the specified BaseInfo message, length delimited. Does not implicitly {@link geelevel.protobuf.BaseInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.BaseInfo
             * @static
             * @param {geelevel.protobuf.IBaseInfo} message BaseInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BaseInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BaseInfo message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.BaseInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.BaseInfo} BaseInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BaseInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.BaseInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.ip = reader.string();
                            break;
                        }
                    case 3: {
                            message.networkType = reader.string();
                            break;
                        }
                    case 4: {
                            message.protocol = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BaseInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.BaseInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.BaseInfo} BaseInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BaseInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BaseInfo message.
             * @function verify
             * @memberof geelevel.protobuf.BaseInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BaseInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id))
                        return "id: integer expected";
                if (message.ip != null && message.hasOwnProperty("ip"))
                    if (!$util.isString(message.ip))
                        return "ip: string expected";
                if (message.networkType != null && message.hasOwnProperty("networkType"))
                    if (!$util.isString(message.networkType))
                        return "networkType: string expected";
                if (message.protocol != null && message.hasOwnProperty("protocol"))
                    if (!$util.isString(message.protocol))
                        return "protocol: string expected";
                return null;
            };

            /**
             * Creates a BaseInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.BaseInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.BaseInfo} BaseInfo
             */
            BaseInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.BaseInfo)
                    return object;
                var message = new $root.geelevel.protobuf.BaseInfo();
                if (object.id != null)
                    message.id = object.id >>> 0;
                if (object.ip != null)
                    message.ip = String(object.ip);
                if (object.networkType != null)
                    message.networkType = String(object.networkType);
                if (object.protocol != null)
                    message.protocol = String(object.protocol);
                return message;
            };

            /**
             * Creates a plain object from a BaseInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.BaseInfo
             * @static
             * @param {geelevel.protobuf.BaseInfo} message BaseInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BaseInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = 0;
                    object.ip = "";
                    object.networkType = "";
                    object.protocol = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.ip != null && message.hasOwnProperty("ip"))
                    object.ip = message.ip;
                if (message.networkType != null && message.hasOwnProperty("networkType"))
                    object.networkType = message.networkType;
                if (message.protocol != null && message.hasOwnProperty("protocol"))
                    object.protocol = message.protocol;
                return object;
            };

            /**
             * Converts this BaseInfo to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.BaseInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BaseInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BaseInfo
             * @function getTypeUrl
             * @memberof geelevel.protobuf.BaseInfo
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BaseInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.BaseInfo";
            };

            return BaseInfo;
        })();

        protobuf.SetVolume = (function() {

            /**
             * Properties of a SetVolume.
             * @memberof geelevel.protobuf
             * @interface ISetVolume
             * @property {number|null} [volume] SetVolume volume
             */

            /**
             * Constructs a new SetVolume.
             * @memberof geelevel.protobuf
             * @classdesc Represents a SetVolume.
             * @implements ISetVolume
             * @constructor
             * @param {geelevel.protobuf.ISetVolume=} [properties] Properties to set
             */
            function SetVolume(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetVolume volume.
             * @member {number} volume
             * @memberof geelevel.protobuf.SetVolume
             * @instance
             */
            SetVolume.prototype.volume = 0;

            /**
             * Creates a new SetVolume instance using the specified properties.
             * @function create
             * @memberof geelevel.protobuf.SetVolume
             * @static
             * @param {geelevel.protobuf.ISetVolume=} [properties] Properties to set
             * @returns {geelevel.protobuf.SetVolume} SetVolume instance
             */
            SetVolume.create = function create(properties) {
                return new SetVolume(properties);
            };

            /**
             * Encodes the specified SetVolume message. Does not implicitly {@link geelevel.protobuf.SetVolume.verify|verify} messages.
             * @function encode
             * @memberof geelevel.protobuf.SetVolume
             * @static
             * @param {geelevel.protobuf.ISetVolume} message SetVolume message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVolume.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.volume);
                return writer;
            };

            /**
             * Encodes the specified SetVolume message, length delimited. Does not implicitly {@link geelevel.protobuf.SetVolume.verify|verify} messages.
             * @function encodeDelimited
             * @memberof geelevel.protobuf.SetVolume
             * @static
             * @param {geelevel.protobuf.ISetVolume} message SetVolume message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetVolume.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetVolume message from the specified reader or buffer.
             * @function decode
             * @memberof geelevel.protobuf.SetVolume
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {geelevel.protobuf.SetVolume} SetVolume
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVolume.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.geelevel.protobuf.SetVolume();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.volume = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetVolume message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof geelevel.protobuf.SetVolume
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {geelevel.protobuf.SetVolume} SetVolume
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetVolume.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetVolume message.
             * @function verify
             * @memberof geelevel.protobuf.SetVolume
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetVolume.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.volume != null && message.hasOwnProperty("volume"))
                    if (!$util.isInteger(message.volume))
                        return "volume: integer expected";
                return null;
            };

            /**
             * Creates a SetVolume message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof geelevel.protobuf.SetVolume
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {geelevel.protobuf.SetVolume} SetVolume
             */
            SetVolume.fromObject = function fromObject(object) {
                if (object instanceof $root.geelevel.protobuf.SetVolume)
                    return object;
                var message = new $root.geelevel.protobuf.SetVolume();
                if (object.volume != null)
                    message.volume = object.volume >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a SetVolume message. Also converts values to other types if specified.
             * @function toObject
             * @memberof geelevel.protobuf.SetVolume
             * @static
             * @param {geelevel.protobuf.SetVolume} message SetVolume
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetVolume.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.volume = 0;
                if (message.volume != null && message.hasOwnProperty("volume"))
                    object.volume = message.volume;
                return object;
            };

            /**
             * Converts this SetVolume to JSON.
             * @function toJSON
             * @memberof geelevel.protobuf.SetVolume
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetVolume.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetVolume
             * @function getTypeUrl
             * @memberof geelevel.protobuf.SetVolume
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetVolume.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/geelevel.protobuf.SetVolume";
            };

            return SetVolume;
        })();

        return protobuf;
    })();

    return geelevel;
})();

module.exports = $root;
